// get human readerable label of gender and category with label or code
export function getLabel(entity) {
  if (entity.label && LABELS[entity.label]) {
    return LABELS[entity.label]['en-US'];
  } else if (entity.label) {
    return entity.label;
  }
  if (entity.code && LABELS[entity.code]) {
    return LABELS[LABELS[entity.code]]['en-US'];
  }
  if (entity.code && CATEGORY[entity.code.toString()]) {
    return CATEGORY[entity.code.toString()].str;
  }
  return entity;
}

// legacy version of getLabel
export function getCategoryName(region) {
  if (region.category1 && LABELS[region.category1.label]) {
    return LABELS[region.category1.label]['en-US'];
  }
  else if (region.category && LABELS[region.category.code] &&
      ['c1', 'c2', 'c3'].indexOf(LABELS[region.category.code].split('.')[0]) > -1 &&
      LABELS[LABELS[region.category.code]]) {
    return LABELS[LABELS[region.category.code]]['en-US'];
  }
  else if (CATEGORY[region.category.code.toString()]) {
    return CATEGORY[region.category.code.toString()].str;
  }
  return '';
}

export const APPS = {
  'fashion3': {
    name: 'Fashion3',
    apibase: 'https://api.pxl.ai/v3',
  },
  'fashion2': {
    name: 'Fashion2',
    apibase: 'https://api.pxl.ai/v2',
  },
  'fashion1': {
    name: 'Fashion1',
    apibase: 'https://api.pxl.ai/v1',
  },
  'tonic1': {
    name: 'Tonic',
    apibase: 'https://api.pxl.ai/v1',
  },
}

// https://gogs.oddconcepts.kr/d2/d2/src/master/d2/bucket/relation_fashion2.yaml
export const RELATION_FASHION2 = {
  "c1_relation": {
    "c1.tops": {
      "child": [
        "c2.outerwears",
        "c2.tops",
        "c2.swimsuits_tops"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c1.bottoms": {
      "child": [
        "c2.pants",
        "c2.skirts",
        "c2.swimsuits_bottoms"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c1.onepiece": {
      "child": [
        "c2.onepiece",
        "c2.swimsuits_onepiece"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c1.bags": {
      "child": [
        "c2.totebags",
        "c2.shoulder_cross_bags",
        "c2.clutch_bags",
        "c2.pouch_bags",
        "c2.backpacks",
        "c2.briefcases",
        "c2.suitcases",
        "c2.fanny_pack",
        "c2.sports_bags"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c1.shoes": {
      "child": [
        "c2.boots",
        "c2.heels_pumps",
        "c2.loafers",
        "c2.sandals",
        "c2.sneakers",
        "c2.sports_shoes"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    }
  },
  "c2_relation": {
    "c2.outerwears": {
      "parent": "c1.tops",
      "child": [
        "c3.cardigans",
        "c3.jumpers",
        "c3.coats",
        "c3.jackets",
        "c3.vests"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.tops": {
      "parent": "c1.tops",
      "child": [
        "c3.tshirts",
        "c3.sweatshirts",
        "c3.hoodies",
        "c3.knitwear",
        "c3.blouses",
        "c3.shirts",
        "c3.bustiers"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.swimsuits_tops": {
      "parent": "c1.tops",
      "child": [
        "c3.bikini_tops",
        "c3.rash_guards"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.swimsuits_bottoms": {
      "parent": "c1.bottoms",
      "child": [
        "c3.bikini_bottoms",
        "c3.swim_briefs",
        "c3.swim_trunks"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c2.swimsuits_onepiece": {
      "parent": "c1.onepiece",
      "child": [
        "c3.onepiece_swimsuits",
        "c3.monokinis",
        "c3.wetsuits"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.pants": {
      "parent": "c1.bottoms",
      "child": [
        "c3.long_pants",
        "c3.capri_pants",
        "c3.short_pants"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c2.skirts": {
      "parent": "c1.bottoms",
      "child": [
        "c3.long_skirts",
        "c3.midi_skirts",
        "c3.mini_skirts"
      ],
      "gender": [
        "gender.female"
      ]
    },
    "c2.onepiece": {
      "parent": "c1.onepiece",
      "child": [
        "c3.dresses",
        "c3.jumpsuits"
      ],
      "gender": [
        "gender.female"
      ]
    },
    "c2.boots": {
      "parent": "c1.shoes",
      "child": [
        "c3.booties",
        "c3.ankle_boots",
        "c3.walkers",
        "c3.long_boots",
        "c3.half_boots",
        "c3.rain_boots",
        "c3.boots"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.heels_pumps": {
      "parent": "c1.shoes",
      "child": [
        "c3.pumps",
        "c3.stiletto_heels",
        "c3.wedge_heels",
        "c3.open_toed_heels",
        "c3.sling_back_shoes",
        "c3.maryjane",
        "c3.strap_sandal_heels"
      ],
      "gender": [
        "gender.female"
      ]
    },
    "c2.loafers": {
      "parent": "c1.shoes",
      "child": [
        "c3.flat_shoes",
        "c3.loafers",
        "c3.bloafers",
        "c3.oxford_shoes",
        "c3.dress_shoes",
        "c3.boat_shoes"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c2.sandals": {
      "parent": "c1.shoes",
      "child": [
        "c3.flat_sandals",
        "c3.platform_sandals",
        "c3.wedge_sandals",
        "c3.gladiator_sandals",
        "c3.slippers",
        "c3.flip_flops",
        "c3.mules",
        "c3.sandals"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.sneakers": {
      "parent": "c1.shoes",
      "child": [
        "c3.hightop_shoes",
        "c3.sneakers",
        "c3.slipon_shoes"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.sports_shoes": {
      "parent": "c1.shoes",
      "child": [
        "c3.hiking_shoes"
      ],
      "gender": [
        "gender.unisex"
      ]
    },
    "c2.totebags": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c2.shoulder_cross_bags": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.clutch_bags": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c2.pouch_bags": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.female"
      ]
    },
    "c2.backpacks": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c2.briefcases": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.male"
      ]
    },
    "c2.suitcases": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.unisex"
      ]
    },
    "c2.fanny_pack": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.unisex"
      ]
    },
    "c2.sports_bags": {
      "parent": "c1.bags",
      "child": [],
      "gender": [
        "gender.unisex"
      ]
    }
  },
  "c3_relation": {
    "c3.cardigans": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.jumpers": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.coats": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.jackets": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.vests": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.tshirts": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.sweatshirts": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.hoodies": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.knitwear": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.blouses": {
      "parent": "c2.tops",
      "gender": [
        "gender.female"
      ]
    },
    "c3.shirts": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.bustiers": {
      "parent": "c2.tops",
      "gender": [
        "gender.female"
      ]
    },
    "c3.bikini_tops": {
      "parent": "c2.swimsuits_tops",
      "gender": [
        "gender.female"
      ]
    },
    "c3.rash_guards": {
      "parent": "c2.swimsuits_tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.long_pants": {
      "parent": "c2.pants",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.capri_pants": {
      "parent": "c2.pants",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.short_pants": {
      "parent": "c2.pants",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.long_skirts": {
      "parent": "c2.skirts",
      "gender": [
        "gender.female"
      ]
    },
    "c3.midi_skirts": {
      "parent": "c2.skirts",
      "gender": [
        "gender.female"
      ]
    },
    "c3.mini_skirts": {
      "parent": "c2.skirts",
      "gender": [
        "gender.female"
      ]
    },
    "c3.bikini_bottoms": {
      "parent": "c2.swimsuits_bottoms",
      "gender": [
        "gender.female"
      ]
    },
    "c3.swim_briefs": {
      "parent": "c2.swimsuits_bottoms",
      "gender": [
        "gender.male"
      ]
    },
    "c3.swim_trunks": {
      "parent": "c2.swimsuits_bottoms",
      "gender": [
        "gender.male"
      ]
    },
    "c3.dresses": {
      "parent": "c2.onepiece",
      "gender": [
        "gender.female"
      ]
    },
    "c3.jumpsuits": {
      "parent": "c2.onepiece",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.onepiece_swimsuits": {
      "parent": "c2.swimsuits_onepiece",
      "gender": [
        "gender.female"
      ]
    },
    "c3.monokinis": {
      "parent": "c2.swimsuits_onepiece",
      "gender": [
        "gender.female"
      ]
    },
    "c3.wetsuits": {
      "parent": "c2.swimsuits_onepiece",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.booties": {
      "parent": "c2.boots",
      "gender": [
        "gender.female"
      ]
    },
    "c3.ankle_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female"
      ]
    },
    "c3.walkers": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.long_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female"
      ]
    },
    "c3.half_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female"
      ]
    },
    "c3.rain_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.male"
      ]
    },
    "c3.pumps": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.stiletto_heels": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.wedge_heels": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.open_toed_heels": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.sling_back_shoes": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.maryjane": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.flat_shoes": {
      "parent": "c2.loafers",
      "gender": [
        "gender.female"
      ]
    },
    "c3.loafers": {
      "parent": "c2.loafers",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.bloafers": {
      "parent": "c2.loafers",
      "gender": [
        "gender.female"
      ]
    },
    "c3.oxford_shoes": {
      "parent": "c2.loafers",
      "gender": [
        "gender.female"
      ]
    },
    "c3.dress_shoes": {
      "parent": "c2.loafers",
      "gender": [
        "gender.male"
      ]
    },
    "c3.boat_shoes": {
      "parent": "c2.loafers",
      "gender": [
        "gender.male"
      ]
    },
    "c3.flat_sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.platform_sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.wedge_sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.gladiator_sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.strap_sandal_heels": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.slippers": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.flip_flops": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.mules": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.hightop_shoes": {
      "parent": "c2.sneakers",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.sneakers": {
      "parent": "c2.sneakers",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.slipon_shoes": {
      "parent": "c2.sneakers",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.hiking_shoes": {
      "parent": "c2.sports_shoes",
      "gender": [
        "gender.unisex"
      ]
    }
  }
}

// https://gogs.oddconcepts.kr/d2/d2/src/master/d2/bucket/relation_fashion3.yaml
export const RELATION_FASHION3 = {
  "c1_relation": {
    "c1.tops": {
      "child": [
        "c2.outerwears",
        "c2.tops",
        "c2.underwear_tops",
        "c2.swimsuit_tops"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c1.bottoms": {
      "child": [
        "c2.pants",
        "c2.skirts",
        "c2.underwear_bottoms",
        "c2.swimsuit_bottoms"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c1.onepiece": {
      "child": [
        "c2.dresses",
        "c2.jumpsuits_overallpants",
        "c2.onepiece",
        "c2.underwear_onepiece",
        "c2.swimsuit_onepiece"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c1.bags": {
      "child": [
        "c2.backpacks",
        "c2.suitcases",
        "c2.sports_bags",
        "c2.handbags",
        "c2.shoulder_crossbags"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c1.shoes": {
      "child": [
        "c2.boots",
        "c2.heels_pumps",
        "c2.flats",
        "c2.dress_shoes",
        "c2.sandals",
        "c2.sneakers",
        "c2.sports_shoes",
        "c2.indoor_shoes"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c1.headwear": {
      "child": [
        "c2.hats"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    }
  },
  "c2_relation": {
    "c2.outerwears": {
      "parent": "c1.tops",
      "child": [
        "c3.cardigans",
        "c3.vests",
        "c3.coats",
        "c3.cape_coats",
        "c3.trench_coats",
        "c3.rider_or_leatherjacket",
        "c3.blazer_or_suitjackets",
        "c3.denim_jackets",
        "c3.trucker_jackets",
        "c3.aviator_jackets",
        "c3.bomber_or_blousonjacket",
        "c3.down_jackets",
        "c3.parkas",
        "c3.field_jackets",
        "c3.sports_outer",
        "c3.furjacket_coats",
        "c3.windbreakers"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.tops": {
      "parent": "c1.tops",
      "child": [
        "c3.tshirts",
        "c3.sweatshirts",
        "c3.hoodies",
        "c3.knitwear",
        "c3.blouses",
        "c3.shirts",
        "c3.bustiers"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.underwear_tops": {
      "parent": "c1.tops",
      "child": [
        "c3.bras",
        "c3.camisoles_slips",
        "c3.running_shirts"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c2.underwear_bottoms": {
      "parent": "c1.bottoms",
      "child": [
        "c3.panties",
        "c3.drawers",
        "c3.underskirts"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c2.underwear_onepiece": {
      "parent": "c1.onepiece",
      "child": [
        "c3.bodysuits"
      ],
      "gender": [
        "gender.female"
      ]
    },
    "c2.swimsuit_tops": {
      "parent": "c1.tops",
      "child": [
        "c3.bikini_tops",
        "c3.rash_guards"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.swimsuit_bottoms": {
      "parent": "c1.bottoms",
      "child": [
        "c3.bikini_bottoms",
        "c3.swim_briefs",
        "c3.swim_trunks"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c2.swimsuit_onepiece": {
      "parent": "c1.onepiece",
      "child": [
        "c3.onepiece_swimsuits",
        "c3.monokinis",
        "c3.wetsuits"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.pants": {
      "parent": "c1.bottoms",
      "child": [
        "c3.long_pants",
        "c3.capri_pants",
        "c3.short_pants"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.skirts": {
      "parent": "c1.bottoms",
      "child": [
        "c3.long_skirts",
        "c3.midi_skirts",
        "c3.mini_skirts"
      ],
      "gender": [
        "gender.female"
      ]
    },
    "c2.dresses": {
      "parent": "c1.onepiece",
      "child": [
        "c3.long_dresses",
        "c3.midi_dresses",
        "c3.mini_dresses"
      ],
      "gender": [
        "gender.female"
      ]
    },
    "c2.jumpsuits_overallpants": {
      "parent": "c1.onepiece",
      "child": [
        "c3.jumpsuits",
        "c3.overall_pants"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c2.onepiece": {
      "parent": "c1.onepiece",
      "child": [
        "c3.ballgown"
      ],
      "gender": [
        "gender.female"
      ]
    },
    "c2.boots": {
      "parent": "c1.shoes",
      "child": [
        "c3.ankleboots_or_booties",
        "c3.mid_calf_boots",
        "c3.uggs",
        "c3.padding_boots",
        "c3.cowboy_boots",
        "c3.chukka_boots",
        "c3.chelsea_boots",
        "c3.walkers",
        "c3.long_boots",
        "c3.rain_boots"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.heels_pumps": {
      "parent": "c1.shoes",
      "child": [
        "c3.pumps",
        "c3.platform_heels",
        "c3.stiletto_heels",
        "c3.wedge_heels",
        "c3.ankle_strap",
        "c3.sling_back_shoes",
        "c3.mule_heels",
        "c3.maryjane"
      ],
      "gender": [
        "gender.female"
      ]
    },
    "c2.flats": {
      "parent": "c1.shoes",
      "child": [
        "c3.flat_shoes",
        "c3.clogs",
        "c3.espadrille",
        "c3.mule_flats"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.dress_shoes": {
      "parent": "c1.shoes",
      "child": [
        "c3.brogue_shoes",
        "c3.loafers",
        "c3.oxford_shoes",
        "c3.monkstraps",
        "c3.boat_shoes"
      ],
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c2.sandals": {
      "parent": "c1.shoes",
      "child": [
        "c3.sandals",
        "c3.flat_sandals",
        "c3.sandal_heels",
        "c3.wedge_sandals",
        "c3.gladiator_sandals",
        "c3.sports_sandals",
        "c3.slides",
        "c3.flip_flops"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.sneakers": {
      "parent": "c1.shoes",
      "child": [
        "c3.hightop_shoes",
        "c3.sneakers",
        "c3.mule_sneakers",
        "c3.slipon_shoes"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.sports_shoes": {
      "parent": "c1.shoes",
      "child": [
        "c3.hiking_shoes",
        "c3.soccer_shoes",
        "c3.golf_shoes",
        "c3.toe_shoes",
        "c3.aqua_shoes",
        "c3.snowboard_shoes"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.indoor_shoes": {
      "parent": "c1.shoes",
      "child": [
        "c3.slippers"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.backpacks": {
      "parent": "c1.bags",
      "child": [
        "c3.backpacks"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.suitcases": {
      "parent": "c1.bags",
      "child": [
        "c3.suitcases"
      ],
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c2.sports_bags": {
      "parent": "c1.bags",
      "child": [
        "c3.duffle_bags",
        "c3.golf_bags",
        "c3.boston_bags",
        "c3.drawstring_bags"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.handbags": {
      "parent": "c1.bags",
      "child": [
        "c3.pouch_bags",
        "c3.briefcases",
        "c3.clutch_bags",
        "c3.handbags",
        "c3.bucket_bags",
        "c3.hobo_bags",
        "c3.kellybags"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.shoulder_crossbags": {
      "parent": "c1.bags",
      "child": [
        "c3.satchel_bags",
        "c3.canteen_bags",
        "c3.messenger_bags",
        "c3.cross_bags",
        "c3.eco_bags",
        "c3.fanny_packs",
        "c3.sling_bags"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c2.hats": {
      "parent": "c1.headwear",
      "child": [
        "c3.beanies",
        "c3.berets",
        "c3.bucket_hats",
        "c3.caps_or_snapbacks",
        "c3.fedora_or_floppy_hat",
        "c3.suncaps",
        "c3.hijabs"
      ],
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    }
  },
  "c3_relation": {
    "c3.cardigans": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.vests": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.coats": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.cape_coats": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female"
      ]
    },
    "c3.trench_coats": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.rider_or_leatherjacket": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.blazer_or_suitjackets": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.denim_jackets": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.trucker_jackets": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.aviator_jackets": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.bomber_or_blousonjacket": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.down_jackets": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.parkas": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.field_jackets": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.sports_outer": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.furjacket_coats": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.windbreakers": {
      "parent": "c2.outerwears",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.tshirts": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.sweatshirts": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.hoodies": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.knitwear": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.blouses": {
      "parent": "c2.tops",
      "gender": [
        "gender.female"
      ]
    },
    "c3.shirts": {
      "parent": "c2.tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.bustiers": {
      "parent": "c2.tops",
      "gender": [
        "gender.female"
      ]
    },
    "c3.bras": {
      "parent": "c2.underwear_tops",
      "gender": [
        "gender.female"
      ]
    },
    "c3.camisoles_slips": {
      "parent": "c2.underwear_tops",
      "gender": [
        "gender.female"
      ]
    },
    "c3.running_shirts": {
      "parent": "c2.underwear_tops",
      "gender": [
        "gender.male"
      ]
    },
    "c3.bikini_tops": {
      "parent": "c2.swimsuit_tops",
      "gender": [
        "gender.female"
      ]
    },
    "c3.rash_guards": {
      "parent": "c2.swimsuit_tops",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.long_pants": {
      "parent": "c2.pants",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.capri_pants": {
      "parent": "c2.pants",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.short_pants": {
      "parent": "c2.pants",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.long_skirts": {
      "parent": "c2.skirts",
      "gender": [
        "gender.female"
      ]
    },
    "c3.midi_skirts": {
      "parent": "c2.skirts",
      "gender": [
        "gender.female"
      ]
    },
    "c3.mini_skirts": {
      "parent": "c2.skirts",
      "gender": [
        "gender.female"
      ]
    },
    "c3.panties": {
      "parent": "c2.underwear_bottoms",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.drawers": {
      "parent": "c2.underwear_bottoms",
      "gender": [
        "gender.female"
      ]
    },
    "c3.underskirts": {
      "parent": "c2.underwear_bottoms",
      "gender": [
        "gender.female"
      ]
    },
    "c3.bikini_bottoms": {
      "parent": "c2.swimsuit_bottoms",
      "gender": [
        "gender.female"
      ]
    },
    "c3.swim_briefs": {
      "parent": "c2.swimsuit_bottoms",
      "gender": [
        "gender.male"
      ]
    },
    "c3.swim_trunks": {
      "parent": "c2.swimsuit_bottoms",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.long_dresses": {
      "parent": "c2.dresses",
      "gender": [
        "gender.female"
      ]
    },
    "c3.midi_dresses": {
      "parent": "c2.dresses",
      "gender": [
        "gender.female"
      ]
    },
    "c3.mini_dresses": {
      "parent": "c2.dresses",
      "gender": [
        "gender.female"
      ]
    },
    "c3.jumpsuits": {
      "parent": "c2.jumpsuits_overallpants",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.overall_pants": {
      "parent": "c2.jumpsuits_overallpants",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.ballgown": {
      "parent": "c2.onepiece",
      "gender": [
        "gender.female"
      ]
    },
    "c3.bodysuits": {
      "parent": "c2.underwear_onepiece",
      "gender": [
        "gender.female"
      ]
    },
    "c3.onepiece_swimsuits": {
      "parent": "c2.swimsuit_onepiece",
      "gender": [
        "gender.female"
      ]
    },
    "c3.monokinis": {
      "parent": "c2.swimsuit_onepiece",
      "gender": [
        "gender.female"
      ]
    },
    "c3.wetsuits": {
      "parent": "c2.swimsuit_onepiece",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.ankleboots_or_booties": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.mid_calf_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.uggs": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c3.padding_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.unisex"
      ]
    },
    "c3.cowboy_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.chukka_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.male"
      ]
    },
    "c3.chelsea_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.walkers": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.long_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female"
      ]
    },
    "c3.rain_boots": {
      "parent": "c2.boots",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.pumps": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.platform_heels": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.stiletto_heels": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.wedge_heels": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.ankle_strap": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.sling_back_shoes": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.mule_heels": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.maryjane": {
      "parent": "c2.heels_pumps",
      "gender": [
        "gender.female"
      ]
    },
    "c3.flat_shoes": {
      "parent": "c2.flats",
      "gender": [
        "gender.female"
      ]
    },
    "c3.clogs": {
      "parent": "c2.flats",
      "gender": [
        "gender.unisex"
      ]
    },
    "c3.espadrille": {
      "parent": "c2.flats",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.mule_flats": {
      "parent": "c2.flats",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.brogue_shoes": {
      "parent": "c2.dress_shoes",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.loafers": {
      "parent": "c2.dress_shoes",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.oxford_shoes": {
      "parent": "c2.dress_shoes",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.monkstraps": {
      "parent": "c2.dress_shoes",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.boat_shoes": {
      "parent": "c2.dress_shoes",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.flat_sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.sandal_heels": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.wedge_sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.gladiator_sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female"
      ]
    },
    "c3.sports_sandals": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.slides": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.flip_flops": {
      "parent": "c2.sandals",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.hightop_shoes": {
      "parent": "c2.sneakers",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.sneakers": {
      "parent": "c2.sneakers",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.mule_sneakers": {
      "parent": "c2.sneakers",
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c3.slipon_shoes": {
      "parent": "c2.sneakers",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.hiking_shoes": {
      "parent": "c2.sports_shoes",
      "gender": [
        "gender.unisex"
      ]
    },
    "c3.soccer_shoes": {
      "parent": "c2.sports_shoes",
      "gender": [
        "gender.male"
      ]
    },
    "c3.golf_shoes": {
      "parent": "c2.sports_shoes",
      "gender": [
        "gender.female",
        "gender.male"
      ]
    },
    "c3.toe_shoes": {
      "parent": "c2.sports_shoes",
      "gender": [
        "gender.female"
      ]
    },
    "c3.aqua_shoes": {
      "parent": "c2.sports_shoes",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.snowboard_shoes": {
      "parent": "c2.sports_shoes",
      "gender": [
        "gender.unisex"
      ]
    },
    "c3.slippers": {
      "parent": "c2.indoor_shoes",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.backpacks": {
      "parent": "c2.backpacks",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.suitcases": {
      "parent": "c2.suitcases",
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c3.duffle_bags": {
      "parent": "c2.sports_bags",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.golf_bags": {
      "parent": "c2.sports_bags",
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c3.boston_bags": {
      "parent": "c2.sports_bags",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.drawstring_bags": {
      "parent": "c2.sports_bags",
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c3.pouch_bags": {
      "parent": "c2.handbags",
      "gender": [
        "gender.female"
      ]
    },
    "c3.briefcases": {
      "parent": "c2.handbags",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.clutch_bags": {
      "parent": "c2.handbags",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.handbags": {
      "parent": "c2.handbags",
      "gender": [
        "gender.female"
      ]
    },
    "c3.bucket_bags": {
      "parent": "c2.handbags",
      "gender": [
        "gender.female"
      ]
    },
    "c3.hobo_bags": {
      "parent": "c2.handbags",
      "gender": [
        "gender.female"
      ]
    },
    "c3.kellybags": {
      "parent": "c2.handbags",
      "gender": [
        "gender.female"
      ]
    },
    "c3.satchel_bags": {
      "parent": "c2.shoulder_crossbags",
      "gender": [
        "gender.female"
      ]
    },
    "c3.canteen_bags": {
      "parent": "c2.shoulder_crossbags",
      "gender": [
        "gender.female"
      ]
    },
    "c3.messenger_bags": {
      "parent": "c2.shoulder_crossbags",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.cross_bags": {
      "parent": "c2.shoulder_crossbags",
      "gender": [
        "gender.female"
      ]
    },
    "c3.eco_bags": {
      "parent": "c2.shoulder_crossbags",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.fanny_packs": {
      "parent": "c2.shoulder_crossbags",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.sling_bags": {
      "parent": "c2.shoulder_crossbags",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.beanies": {
      "parent": "c2.hats",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.berets": {
      "parent": "c2.hats",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.bucket_hats": {
      "parent": "c2.hats",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.caps_or_snapbacks": {
      "parent": "c2.hats",
      "gender": [
        "gender.female",
        "gender.male",
        "gender.unisex"
      ]
    },
    "c3.fedora_or_floppy_hat": {
      "parent": "c2.hats",
      "gender": [
        "gender.female"
      ]
    },
    "c3.suncaps": {
      "parent": "c2.hats",
      "gender": [
        "gender.female",
        "gender.unisex"
      ]
    },
    "c3.hijabs": {
      "parent": "c2.hats",
      "gender": [
        "gender.female"
      ]
    }
  }
};

export const RELATIONS = {
  'fashion2': RELATION_FASHION2,
  'fashion3': RELATION_FASHION3
}

// http://dist.pxl.ai/strings/labels-latest.json
export const LABELS = {
  "@version": "0.2.4",
  "@date": "2021-12-09T20:29:03.180663",
  "gender.unknown": {
    "ko-KR": "알 수 없음",
    "code": 317,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "gender.female": {
    "ko-KR": "여성",
    "code": 536870912,
    "en-US": "Female",
    "lv-LV": "-1",
    "ja-JP": "レディース"
  },
  "gender.male": {
    "ko-KR": "남성",
    "code": 1073741824,
    "en-US": "Male",
    "lv-LV": "-1",
    "ja-JP": "メンズ"
  },
  "gender.unisex": {
    "ko-KR": "남녀공용",
    "code": 1610612736,
    "en-US": "Unisex",
    "lv-LV": "-1",
    "ja-JP": "ユニセックス"
  },
  "gender.child_female": {
    "ko-KR": "여자아이",
    "code": 805306368,
    "en-US": "Girl",
    "lv-LV": "-1",
    "ja-JP": "女児"
  },
  "gender.child_male": {
    "ko-KR": "남자아이",
    "code": 1342177280,
    "en-US": "Boy",
    "lv-LV": "-1",
    "ja-JP": "男児"
  },
  "gender.child_unisex": {
    "ko-KR": "남여공용(어린이)",
    "code": 1879048192,
    "en-US": "Unisex",
    "lv-LV": "-1",
    "ja-JP": "男女同権の子供"
  },
  "gender.unsupported": {
    "ko-KR": "미지원",
    "code": 334,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "unknown": {
    "ko-KR": "알 수 없음",
    "code": 0,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "c1.unknown": {
    "ko-KR": "알 수 없음",
    "code": 302,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "c1.unsupported": {
    "ko-KR": "미지원",
    "code": 333,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "c1.tops": {
    "ko-KR": "상의",
    "code": 201,
    "en-US": "Tops",
    "lv-LV": "-1",
    "ja-JP": "トップス"
  },
  "c1.bottoms": {
    "ko-KR": "하의",
    "code": 202,
    "en-US": "Bottoms",
    "lv-LV": "-1",
    "ja-JP": "ボトムス"
  },
  "c1.onepiece": {
    "ko-KR": "원피스",
    "code": 203,
    "en-US": "One piece",
    "lv-LV": "-1",
    "ja-JP": "全身"
  },
  "c1.bags": {
    "ko-KR": "가방",
    "code": 204,
    "en-US": "Bags",
    "lv-LV": "-1",
    "ja-JP": "袋"
  },
  "c1.shoes": {
    "ko-KR": "신발",
    "code": 205,
    "en-US": "Shoes",
    "lv-LV": "-1",
    "ja-JP": "靴"
  },
  "c1.face": {
    "ko-KR": "얼굴",
    "code": 200,
    "en-US": "Face",
    "lv-LV": "-1",
    "ja-JP": "顔"
  },
  "c1.headwear": {
    "ko-KR": "머리장식",
    "code": 888,
    "en-US": "Headwear",
    "lv-LV": "-1",
    "ja-JP": "帽子"
  },
  "c1.accessories": {
    "ko-KR": "잡화",
    "code": 343,
    "en-US": "Accessories",
    "lv-LV": "-1",
    "ja-JP": "付属品"
  },
  "c2.unknown": {
    "ko-KR": "알 수 없음",
    "code": 303,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "c2.unsupported": {
    "ko-KR": "미지원",
    "code": 332,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "c2.outerwears": {
    "ko-KR": "아우터",
    "code": 206,
    "en-US": "Outerwears",
    "lv-LV": "-1",
    "ja-JP": "上着"
  },
  "c2.tops": {
    "ko-KR": "상의",
    "code": 207,
    "en-US": "Tops",
    "lv-LV": "-1",
    "ja-JP": "トップス"
  },
  "c2.underwear": {
    "ko-KR": "속옷",
    "code": 50320,
    "en-US": "Underwear",
    "lv-LV": "300",
    "ja-JP": "下着"
  },
  "c2.swimsuits": {
    "ko-KR": "수영복",
    "code": 50319,
    "en-US": "Swimsuits",
    "lv-LV": "301",
    "ja-JP": "水着"
  },
  "c2.underwear_tops": {
    "ko-KR": "속옷 상의",
    "code": 208,
    "en-US": "Underwear tops",
    "lv-LV": "-1",
    "ja-JP": "下着のトップス"
  },
  "c2.swimsuits_tops": {
    "ko-KR": "수영복 상의",
    "code": 50322,
    "en-US": "Swimsuit tops",
    "lv-LV": "209",
    "ja-JP": "PropertyTuple(data='swimsuit, tops', meta={})"
  },
  "c2.pants": {
    "ko-KR": "바지",
    "code": 210,
    "en-US": "Pants",
    "lv-LV": "-1",
    "ja-JP": "パンツ"
  },
  "c2.skirts": {
    "ko-KR": "스커트",
    "code": 211,
    "en-US": "Skirts",
    "lv-LV": "-1",
    "ja-JP": "スカート"
  },
  "c2.underwear_bottoms": {
    "ko-KR": "속옷 하의",
    "code": 212,
    "en-US": "Underwear bottoms",
    "lv-LV": "-1",
    "ja-JP": "下着の底"
  },
  "c2.swimsuits_bottoms": {
    "ko-KR": "수영복 하의",
    "code": 50323,
    "en-US": "Swimsuit bottoms",
    "lv-LV": "213",
    "ja-JP": "PropertyTuple(data='swimsuit, bottoms', meta={})"
  },
  "c2.onepiece": {
    "ko-KR": "드레스류 원피스",
    "code": 214,
    "en-US": "One piece",
    "lv-LV": "-1",
    "ja-JP": "一つのもの"
  },
  "c2.dresses": {
    "ko-KR": "원피스",
    "code": 949,
    "en-US": "Dresses",
    "lv-LV": "-1",
    "ja-JP": "ドレス"
  },
  "c2.jumpsuits_overallpants": {
    "ko-KR": "점프수트/멜빵바지",
    "code": 889,
    "en-US": "Jumpsuits/Overall pants",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='jumpsuits or overallpants', meta={})"
  },
  "c2.underwear_onepiece": {
    "ko-KR": "속옷 원피스",
    "code": 215,
    "en-US": "One piece underwear",
    "lv-LV": "-1",
    "ja-JP": "下着1着"
  },
  "c2.swimsuits_onepiece": {
    "ko-KR": "수영복 원피스",
    "code": 50324,
    "en-US": "One piece swimsuits",
    "lv-LV": "216",
    "ja-JP": "PropertyTuple(data='swimsuit, one-piece', meta={})"
  },
  "c2.boots": {
    "ko-KR": "부츠",
    "code": 217,
    "en-US": "Boots",
    "lv-LV": "-1",
    "ja-JP": "ブーツ"
  },
  "c2.heels_pumps": {
    "ko-KR": "힐/펌프스 구두",
    "code": 218,
    "en-US": "Heels/Pumps",
    "lv-LV": "-1",
    "ja-JP": "ヒール·パンプス"
  },
  "c2.loafers": {
    "ko-KR": "로퍼",
    "code": 219,
    "en-US": "Loafers",
    "lv-LV": "-1",
    "ja-JP": "ローファー"
  },
  "c2.sandals": {
    "ko-KR": "샌들",
    "code": 220,
    "en-US": "Sandals",
    "lv-LV": "-1",
    "ja-JP": "サンダル"
  },
  "c2.sneakers": {
    "ko-KR": "운동화",
    "code": 221,
    "en-US": "Sneakers",
    "lv-LV": "-1",
    "ja-JP": "運動靴"
  },
  "c2.sports_shoes": {
    "ko-KR": "스포츠 신발",
    "code": 222,
    "en-US": "Sports shoes",
    "lv-LV": "-1",
    "ja-JP": "運動靴"
  },
  "c2.dress_shoes": {
    "ko-KR": "정장 구두",
    "code": 950,
    "en-US": "Dress shoes",
    "lv-LV": "-1",
    "ja-JP": "礼装靴"
  },
  "c2.indoor_shoes": {
    "ko-KR": "실내화",
    "code": 890,
    "en-US": "Indoor shoes",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='indoor shoes', meta={})"
  },
  "c2.flats": {
    "ko-KR": "단화",
    "code": 957,
    "en-US": "Flats",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='flats', meta={})"
  },
  "c2.totebags": {
    "ko-KR": "토트백",
    "code": 223,
    "en-US": "Tote bags",
    "lv-LV": "-1",
    "ja-JP": "トートバッグ"
  },
  "c2.shoulder_crossbags": {
    "ko-KR": "숄더/크로스백",
    "code": 960,
    "en-US": "Shoulder/Cross bags",
    "lv-LV": "-1",
    "ja-JP": "ショルダークロスバッグ"
  },
  "c2.shoulder_cross_bags": {
    "ko-KR": "숄더/크로스백",
    "code": 224,
    "en-US": "Shoulder/Cross bags",
    "lv-LV": "-1",
    "ja-JP": "ショルダークロスバッグ"
  },
  "c2.clutch_bags": {
    "ko-KR": "클러치백",
    "code": 225,
    "en-US": "Clutch bags",
    "lv-LV": "-1",
    "ja-JP": "クラッチバッグ"
  },
  "c2.pouch_bags": {
    "ko-KR": "파우치백",
    "code": 226,
    "en-US": "Pouch bags",
    "lv-LV": "-1",
    "ja-JP": "ポーチ·バッグ"
  },
  "c2.backpacks": {
    "ko-KR": "백팩",
    "code": 227,
    "en-US": "Backpacks",
    "lv-LV": "-1",
    "ja-JP": "リュックサック"
  },
  "c2.briefcases": {
    "ko-KR": "서류가방",
    "code": 228,
    "en-US": "Briefcases",
    "lv-LV": "-1",
    "ja-JP": "ブリーフケース"
  },
  "c2.suitcases": {
    "ko-KR": "캐리어",
    "code": 229,
    "en-US": "Suitcases",
    "lv-LV": "-1",
    "ja-JP": "スーツケース"
  },
  "c2.fanny_pack": {
    "ko-KR": "힙색",
    "code": 230,
    "en-US": "Fanny packs",
    "lv-LV": "-1",
    "ja-JP": "ファニー·パック"
  },
  "c2.sports_bags": {
    "ko-KR": "스포츠백",
    "code": 231,
    "en-US": "Sports bags",
    "lv-LV": "-1",
    "ja-JP": "スポーツバッグ"
  },
  "c2.handbags": {
    "ko-KR": "핸드백",
    "code": 891,
    "en-US": "Hand bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='hand bags', meta={})"
  },
  "c2.belts": {
    "ko-KR": "벨트",
    "code": 344,
    "en-US": "Belts",
    "lv-LV": "-1",
    "ja-JP": "ベルト"
  },
  "c2.gloves": {
    "ko-KR": "장갑",
    "code": 345,
    "en-US": "Gloves",
    "lv-LV": "-1",
    "ja-JP": "手袋"
  },
  "c2.hats": {
    "ko-KR": "모자",
    "code": 346,
    "en-US": "Hats",
    "lv-LV": "-1",
    "ja-JP": "帽子"
  },
  "c2.inners": {
    "ko-KR": "이너",
    "code": 347,
    "en-US": "Inners",
    "lv-LV": "-1",
    "ja-JP": "内部"
  },
  "c2.jewelry": {
    "ko-KR": "쥬얼리",
    "code": 348,
    "en-US": "Jewelry",
    "lv-LV": "-1",
    "ja-JP": "宝飾品"
  },
  "c2.necktie": {
    "ko-KR": "넥타이",
    "code": 349,
    "en-US": "Necktie",
    "lv-LV": "-1",
    "ja-JP": "ネクタイ"
  },
  "c2.scarf_or_muffler": {
    "ko-KR": "스카프/목도리",
    "code": 350,
    "en-US": "Scarf/Muffler",
    "lv-LV": "-1",
    "ja-JP": "スカーフやマフラー"
  },
  "c2.socks_or_tights": {
    "ko-KR": "양말/타이즈",
    "code": 351,
    "en-US": "Socks/Tights",
    "lv-LV": "-1",
    "ja-JP": "靴下やタイツ"
  },
  "c2.sunglasses_or_eye_glasses": {
    "ko-KR": "선글라스/안경",
    "code": 352,
    "en-US": "Sunglasses/Eyeglasses",
    "lv-LV": "-1",
    "ja-JP": "サングラスまたは眼鏡"
  },
  "c2.wallets": {
    "ko-KR": "지갑",
    "code": 353,
    "en-US": "Wallets",
    "lv-LV": "-1",
    "ja-JP": "財布"
  },
  "c2.watches": {
    "ko-KR": "시계",
    "code": 354,
    "en-US": "Watches",
    "lv-LV": "-1",
    "ja-JP": "腕時計"
  },
  "c2.swimsuit_bottoms": {
    "ko-KR": "수영복 하의",
    "code": 842,
    "en-US": "Swimsuit bottoms",
    "lv-LV": "-1",
    "ja-JP": "水着ボトムス"
  },
  "c2.swimsuit_tops": {
    "ko-KR": "수영복 상의",
    "code": 841,
    "en-US": "Swimsuit tops",
    "lv-LV": "-1",
    "ja-JP": "水着のトップス"
  },
  "c2.swimsuit_onepiece": {
    "ko-KR": "수영복 원피스",
    "code": 843,
    "en-US": "One piece swimsuits",
    "lv-LV": "-1",
    "ja-JP": "水着ワンピース"
  },
  "c3.none": {
    "ko-KR": "없음",
    "code": 318,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "c3.unknown": {
    "ko-KR": "알 수 없음",
    "code": 304,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "c3.unsupported": {
    "ko-KR": "미지원",
    "code": 331,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "c3.cardigans": {
    "ko-KR": "가디건",
    "code": 232,
    "en-US": "Cardigans",
    "lv-LV": "-1",
    "ja-JP": "カーディガン"
  },
  "c3.jumpers": {
    "ko-KR": "점퍼",
    "code": 233,
    "en-US": "Jumpers",
    "lv-LV": "-1",
    "ja-JP": "ジャンパ"
  },
  "c3.coats": {
    "ko-KR": "코트",
    "code": 234,
    "en-US": "Coats",
    "lv-LV": "-1",
    "ja-JP": "コート"
  },
  "c3.jackets": {
    "ko-KR": "자켓",
    "code": 235,
    "en-US": "Jackets",
    "lv-LV": "-1",
    "ja-JP": "ジャケット"
  },
  "c3.vests": {
    "ko-KR": "아우터 조끼",
    "code": 236,
    "en-US": "Outwear Vests",
    "lv-LV": "-1",
    "ja-JP": "ベスト"
  },
  "c3.cape_coats": {
    "ko-KR": "망토",
    "code": 892,
    "en-US": "Cape coats",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='cape coats', meta={})"
  },
  "c3.trench_coats": {
    "ko-KR": "트렌치코트",
    "code": 893,
    "en-US": "Trench coats",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='trench coats', meta={})"
  },
  "c3.rider_or_leatherjacket": {
    "ko-KR": "라이더/가죽 자켓",
    "code": 894,
    "en-US": "Rider/Leather jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='rider or leather jackets', meta={})"
  },
  "c3.blazer_or_suitjackets": {
    "ko-KR": "블레이저/정장 자켓",
    "code": 895,
    "en-US": "Blazer/Suit jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='blazer or suit jackets', meta={})"
  },
  "c3.denim_jackets": {
    "ko-KR": "청자켓",
    "code": 896,
    "en-US": "Denim jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='denim jackets', meta={})"
  },
  "c3.trucker_jackets": {
    "ko-KR": "트러커 자켓",
    "code": 897,
    "en-US": "Trucker jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='trucker jackets', meta={})"
  },
  "c3.aviator_jackets": {
    "ko-KR": "무스탕",
    "code": 898,
    "en-US": "Aviator jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='aviator jackets', meta={})"
  },
  "c3.bomber_or_blousonjacket": {
    "ko-KR": "봄버/블루종 점퍼",
    "code": 899,
    "en-US": "Bomber/Blouson jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='bomber or blousonjacket', meta={})"
  },
  "c3.down_jackets": {
    "ko-KR": "다운패딩",
    "code": 900,
    "en-US": "Down jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='down jackets', meta={})"
  },
  "c3.parkas": {
    "ko-KR": "파카",
    "code": 901,
    "en-US": "Parkas",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='parkas', meta={})"
  },
  "c3.field_jackets": {
    "ko-KR": "필드/밀리터리 자켓",
    "code": 902,
    "en-US": "Field jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='field jackets', meta={})"
  },
  "c3.sports_outer": {
    "ko-KR": "스포츠 점퍼",
    "code": 903,
    "en-US": "Sports jackets",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='sports outer', meta={})"
  },
  "c3.furjacket_coats": {
    "ko-KR": "퍼자켓/코트",
    "code": 904,
    "en-US": "Fur jackets/coats",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='furjacket coats', meta={})"
  },
  "c3.windbreakers": {
    "ko-KR": "바람막이",
    "code": 905,
    "en-US": "Windbreakers",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='windbreakers', meta={})"
  },
  "c3.tshirts": {
    "ko-KR": "티셔츠",
    "code": 237,
    "en-US": "T-shirts",
    "lv-LV": "-1",
    "ja-JP": "シャツ"
  },
  "c3.sweatshirts": {
    "ko-KR": "맨투맨",
    "code": 238,
    "en-US": "Sweatshirts",
    "lv-LV": "-1",
    "ja-JP": "スウェット·シャツ"
  },
  "c3.hoodies": {
    "ko-KR": "후드",
    "code": 239,
    "en-US": "Hoodies",
    "lv-LV": "-1",
    "ja-JP": "パーカー"
  },
  "c3.knitwear": {
    "ko-KR": "니트",
    "code": 240,
    "en-US": "Knitwears",
    "lv-LV": "-1",
    "ja-JP": "編物"
  },
  "c3.blouses": {
    "ko-KR": "블라우스",
    "code": 241,
    "en-US": "Blouses",
    "lv-LV": "-1",
    "ja-JP": "ブラウス"
  },
  "c3.shirts": {
    "ko-KR": "셔츠",
    "code": 242,
    "en-US": "Shirts",
    "lv-LV": "-1",
    "ja-JP": "シャツ"
  },
  "c3.bustiers": {
    "ko-KR": "뷔스티에",
    "code": 243,
    "en-US": "Bustiers",
    "lv-LV": "-1",
    "ja-JP": "バスティア"
  },
  "c3.bras": {
    "ko-KR": "브레지어",
    "code": 244,
    "en-US": "Bras",
    "lv-LV": "-1",
    "ja-JP": "ブラジャー"
  },
  "c3.camisoles_slips": {
    "ko-KR": "캐미솔/슬립",
    "code": 245,
    "en-US": "Camisoles/Slips",
    "lv-LV": "-1",
    "ja-JP": "キャミソールスリップ"
  },
  "c3.running_shirts": {
    "ko-KR": "민소매 런닝",
    "code": 246,
    "en-US": "Undershirts",
    "lv-LV": "-1",
    "ja-JP": "ランニングシャツ"
  },
  "c3.bikini_tops": {
    "ko-KR": "비키니 상의",
    "code": 247,
    "en-US": "Bikini tops",
    "lv-LV": "-1",
    "ja-JP": "ビキニトップス"
  },
  "c3.rash_guards": {
    "ko-KR": "래시가드",
    "code": 248,
    "en-US": "Rash guards",
    "lv-LV": "-1",
    "ja-JP": "軽率な警備員"
  },
  "c3.long_pants": {
    "ko-KR": "긴 바지",
    "code": 249,
    "en-US": "Long pants",
    "lv-LV": "-1",
    "ja-JP": "長ズボン"
  },
  "c3.capri_pants": {
    "ko-KR": "7부 바지",
    "code": 250,
    "en-US": "Capri pants",
    "lv-LV": "-1",
    "ja-JP": "キャプリパンツ"
  },
  "c3.short_pants": {
    "ko-KR": "반바지",
    "code": 251,
    "en-US": "Short pants",
    "lv-LV": "-1",
    "ja-JP": "ショートパンツ"
  },
  "c3.long_skirts": {
    "ko-KR": "롱 스커트",
    "code": 252,
    "en-US": "Long skirts",
    "lv-LV": "-1",
    "ja-JP": "長いスカート"
  },
  "c3.midi_skirts": {
    "ko-KR": "미디 스커트",
    "code": 253,
    "en-US": "Midi skirts",
    "lv-LV": "-1",
    "ja-JP": "ミディスカート"
  },
  "c3.mini_skirts": {
    "ko-KR": "미니 스커트",
    "code": 254,
    "en-US": "Mini skirts",
    "lv-LV": "-1",
    "ja-JP": "ミニスカート"
  },
  "c3.panties": {
    "ko-KR": "팬티",
    "code": 255,
    "en-US": "Panties",
    "lv-LV": "-1",
    "ja-JP": "パンティー"
  },
  "c3.drawers": {
    "ko-KR": "사각팬티",
    "code": 256,
    "en-US": "Underpants",
    "lv-LV": "-1",
    "ja-JP": "引き出し"
  },
  "c3.underskirts": {
    "ko-KR": "속치마",
    "code": 257,
    "en-US": "Underskirts",
    "lv-LV": "-1",
    "ja-JP": "アンダースカート"
  },
  "c3.bikini_bottoms": {
    "ko-KR": "비키니 하의",
    "code": 258,
    "en-US": "Bikini bottoms",
    "lv-LV": "-1",
    "ja-JP": "ビキニボトムス"
  },
  "c3.swim_briefs": {
    "ko-KR": "삼각 수영복",
    "code": 259,
    "en-US": "Swim briefs",
    "lv-LV": "-1",
    "ja-JP": "水泳パンツ"
  },
  "c3.swim_trunks": {
    "ko-KR": "트렁크 수영복",
    "code": 260,
    "en-US": "Swim trunks",
    "lv-LV": "-1",
    "ja-JP": "水泳パンツ"
  },
  "c3.dresses": {
    "ko-KR": "원피스",
    "code": 261,
    "en-US": "Dresses",
    "lv-LV": "-1",
    "ja-JP": "ドレス"
  },
  "c3.long_dresses": {
    "ko-KR": "롱 원피스",
    "code": 906,
    "en-US": "Long dresses",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='long dresses', meta={})"
  },
  "c3.midi_dresses": {
    "ko-KR": "미디 원피스",
    "code": 907,
    "en-US": "Midi dresses",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='midi dresses', meta={})"
  },
  "c3.mini_dresses": {
    "ko-KR": "미니 원피스",
    "code": 908,
    "en-US": "Mini dresses",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='mini dresses', meta={})"
  },
  "c3.overall_pants": {
    "ko-KR": "멜빵바지",
    "code": 909,
    "en-US": "Overall pants",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='overall pants', meta={})"
  },
  "c3.long_overall_pants": {
    "ko-KR": "롱멜빵바지",
    "code": 310,
    "en-US": "Long overall pants",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='long overall pants', meta={})"
  },
  "c3.midi_overall_pants": {
    "ko-KR": "미디멜빵바지",
    "code": 315,
    "en-US": "Midi overall pants",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='midi overall pants', meta={})"
  },
  "c3.mini_overall_pants": {
    "ko-KR": "미니멜빵바지",
    "code": 324,
    "en-US": "Mini overall pants",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='mini overall pants', meta={})"
  },
  "c3.ballgown": {
    "ko-KR": "볼가운",
    "code": 910,
    "en-US": "Ballgowns",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='ballgown', meta={})"
  },
  "c3.jumpsuits": {
    "ko-KR": "점프수트",
    "code": 262,
    "en-US": "Jumpsuits",
    "lv-LV": "-1",
    "ja-JP": "ジャンプスーツ"
  },
  "c3.long_jumpsuits": {
    "ko-KR": "롱점프슈트",
    "code": 300,
    "en-US": "Long jumpsuits",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='long jumpsuits', meta={})"
  },
  "c3.midi_jumpsuits": {
    "ko-KR": "미디점프슈트",
    "code": 301,
    "en-US": "Midi jumpsuits",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='midi jumpsuits', meta={})"
  },
  "c3.mini_jumpsuits": {
    "ko-KR": "미니점프슈트",
    "code": 305,
    "en-US": "Mini jumpsuits",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='mini jumpsuits', meta={})"
  },
  "c3.yukatas_kimonos": {
    "ko-KR": "유카타/기모노",
    "code": 263,
    "en-US": "Yukatas/kimonos",
    "lv-LV": "-1",
    "ja-JP": "浴衣"
  },
  "c3.bodysuits": {
    "ko-KR": "바디수트",
    "code": 264,
    "en-US": "Bodysuits",
    "lv-LV": "-1",
    "ja-JP": "ボディースーツ"
  },
  "c3.onepiece_swimsuits": {
    "ko-KR": "수영복 원피스",
    "code": 265,
    "en-US": "One piece swimsuits",
    "lv-LV": "-1",
    "ja-JP": "ワンピースの水着"
  },
  "c3.monokinis": {
    "ko-KR": "모노키니",
    "code": 266,
    "en-US": "Monokinis",
    "lv-LV": "-1",
    "ja-JP": "モノキニ"
  },
  "c3.wetsuits": {
    "ko-KR": "다이빙복",
    "code": 267,
    "en-US": "Wetsuits",
    "lv-LV": "-1",
    "ja-JP": "ウェットスーツ"
  },
  "c3.booties": {
    "ko-KR": "부티",
    "code": 268,
    "en-US": "Booties",
    "lv-LV": "-1",
    "ja-JP": "ブート"
  },
  "c3.ankle_boots": {
    "ko-KR": "앵클부츠",
    "code": 269,
    "en-US": "Ankle boots",
    "lv-LV": "-1",
    "ja-JP": "アンクル·ブーツ"
  },
  "c3.walkers": {
    "ko-KR": "워커",
    "code": 270,
    "en-US": "Walkers",
    "lv-LV": "-1",
    "ja-JP": "歩行者"
  },
  "c3.long_boots": {
    "ko-KR": "롱부츠",
    "code": 271,
    "en-US": "Long boots",
    "lv-LV": "-1",
    "ja-JP": "長靴"
  },
  "c3.half_boots": {
    "ko-KR": "하프부츠",
    "code": 272,
    "en-US": "Half boots",
    "lv-LV": "-1",
    "ja-JP": "ハーフブーツ"
  },
  "c3.rain_boots": {
    "ko-KR": "장화",
    "code": 273,
    "en-US": "Rain boots",
    "lv-LV": "-1",
    "ja-JP": "雨靴"
  },
  "c3.boots": {
    "ko-KR": "부츠",
    "code": 274,
    "en-US": "Boots",
    "lv-LV": "-1",
    "ja-JP": "ブーツ"
  },
  "c3.pumps": {
    "ko-KR": "펌프스",
    "code": 275,
    "en-US": "Pumps",
    "lv-LV": "-1",
    "ja-JP": "パンプス"
  },
  "c3.stiletto_heels": {
    "ko-KR": "스틸레토 구두",
    "code": 276,
    "en-US": "Stiletto heels",
    "lv-LV": "-1",
    "ja-JP": "スチルトヒール"
  },
  "c3.wedge_heels": {
    "ko-KR": "통굽 구두",
    "code": 277,
    "en-US": "Wedge heels",
    "lv-LV": "-1",
    "ja-JP": "ウェッジヒール"
  },
  "c3.open_toed_heels": {
    "ko-KR": "토오픈힐",
    "code": 278,
    "en-US": "Open-toed heels",
    "lv-LV": "-1",
    "ja-JP": "つま先の開いたヒール"
  },
  "c3.sling_back_shoes": {
    "ko-KR": "슬링백구두",
    "code": 279,
    "en-US": "Sling back shoes",
    "lv-LV": "-1",
    "ja-JP": "靴を後ろに投げる"
  },
  "c3.maryjane_strap_heels": {
    "ko-KR": "메리제인/스트랩힐",
    "code": 50000,
    "en-US": "Mary jane shoes/strap heels",
    "lv-LV": "-1",
    "ja-JP": "メリージェーンストラップヒール"
  },
  "c3.maryjane": {
    "ko-KR": "메리제인구두",
    "code": 280,
    "en-US": "Mary jane shoes",
    "lv-LV": "-1",
    "ja-JP": "メリージェーン"
  },
  "c3.flat_shoes": {
    "ko-KR": "플랫슈즈",
    "code": 281,
    "en-US": "Flat shoes",
    "lv-LV": "-1",
    "ja-JP": "平たい靴"
  },
  "c3.loafers": {
    "ko-KR": "로퍼",
    "code": 282,
    "en-US": "Loafers",
    "lv-LV": "-1",
    "ja-JP": "ローファー"
  },
  "c3.bloafers": {
    "ko-KR": "블로퍼",
    "code": 283,
    "en-US": "Bloafers",
    "lv-LV": "-1",
    "ja-JP": "送風機"
  },
  "c3.oxford_shoes": {
    "ko-KR": "옥스포드 구두",
    "code": 284,
    "en-US": "Oxford shoes",
    "lv-LV": "-1",
    "ja-JP": "オックスフォード靴"
  },
  "c3.flat_sandals": {
    "ko-KR": "플랫샌들",
    "code": 285,
    "en-US": "Flat sandals",
    "lv-LV": "-1",
    "ja-JP": "平たいサンダル"
  },
  "c3.platform_sandals": {
    "ko-KR": "플랫폼샌들",
    "code": 286,
    "en-US": "Platform sandals",
    "lv-LV": "-1",
    "ja-JP": "プラットフォームサンダル"
  },
  "c3.wedge_sandals": {
    "ko-KR": "웨지샌들",
    "code": 287,
    "en-US": "Wedge sandals",
    "lv-LV": "-1",
    "ja-JP": "ウェッジサンダル"
  },
  "c3.gladiator_sandals": {
    "ko-KR": "글래디에이터샌들",
    "code": 288,
    "en-US": "Gladiator sandals",
    "lv-LV": "-1",
    "ja-JP": "グラディエーターサンダル"
  },
  "c3.strap_sandals": {
    "ko-KR": "스트랩샌들",
    "code": 50001,
    "en-US": "Strap sandals",
    "lv-LV": "-1",
    "ja-JP": "ストラップサンダル"
  },
  "c3.strap_sandal_heels": {
    "ko-KR": "스트랩샌들힐",
    "code": 289,
    "en-US": "Strap sandal heels",
    "lv-LV": "-1",
    "ja-JP": "サンダルのかかとをひもで縛る."
  },
  "c3.slippers": {
    "ko-KR": "실내화",
    "code": 290,
    "en-US": "Slippers",
    "lv-LV": "-1",
    "ja-JP": "スリッパ"
  },
  "c3.flip_flops": {
    "ko-KR": "쪼리",
    "code": 291,
    "en-US": "Flip flops",
    "lv-LV": "-1",
    "ja-JP": "フリップフロップ"
  },
  "c3.mules": {
    "ko-KR": "뮬",
    "code": 292,
    "en-US": "Mules",
    "lv-LV": "-1",
    "ja-JP": "ラバ"
  },
  "c3.hightop_shoes": {
    "ko-KR": "하이탑 운동화",
    "code": 293,
    "en-US": "High top shoes",
    "lv-LV": "-1",
    "ja-JP": "ハイトップ·シューズ"
  },
  "c3.sneakers": {
    "ko-KR": "운동화",
    "code": 294,
    "en-US": "Sneakers",
    "lv-LV": "-1",
    "ja-JP": "運動靴"
  },
  "c3.slipon_shoes": {
    "ko-KR": "슬립온",
    "code": 295,
    "en-US": "Slip on shoes",
    "lv-LV": "-1",
    "ja-JP": "靴をすべる"
  },
  "c3.dress_shoes": {
    "ko-KR": "정장화",
    "code": 296,
    "en-US": "Dress shoes",
    "lv-LV": "-1",
    "ja-JP": "礼装靴"
  },
  "c3.boat_shoes": {
    "ko-KR": "보트 슈즈",
    "code": 297,
    "en-US": "Boat shoes",
    "lv-LV": "-1",
    "ja-JP": "ボートシューズ"
  },
  "c3.sandals": {
    "ko-KR": "샌들",
    "code": 298,
    "en-US": "Sandals",
    "lv-LV": "-1",
    "ja-JP": "サンダル"
  },
  "c3.hiking_shoes": {
    "ko-KR": "등산화",
    "code": 299,
    "en-US": "Hiking shoes",
    "lv-LV": "-1",
    "ja-JP": "登山靴"
  },
  "c3.ankleboots_or_booties": {
    "ko-KR": "앵클부츠/부티",
    "code": 911,
    "en-US": "Ankle boots/Booties",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='ankleboots or booties', meta={})"
  },
  "c3.mid_calf_boots": {
    "ko-KR": "반부츠",
    "code": 912,
    "en-US": "Mid calf boots",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='mid calf boots', meta={})"
  },
  "c3.uggs": {
    "ko-KR": "어그부츠",
    "code": 913,
    "en-US": "Uggs",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='uggs', meta={})"
  },
  "c3.padding_boots": {
    "ko-KR": "패딩 부츠",
    "code": 914,
    "en-US": "Padding boots",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='padding boots', meta={})"
  },
  "c3.cowboy_boots": {
    "ko-KR": "카우보이 부츠",
    "code": 915,
    "en-US": "Cowboy boots",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='cowboy boots', meta={})"
  },
  "c3.chukka_boots": {
    "ko-KR": "처커 부츠",
    "code": 916,
    "en-US": "Chukka boots",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='chukka boots', meta={})"
  },
  "c3.chelsea_boots": {
    "ko-KR": "첼시 부츠",
    "code": 917,
    "en-US": "Chlesea boots",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='chelsea boots', meta={})"
  },
  "c3.platform_heels": {
    "ko-KR": "가보시 구두",
    "code": 918,
    "en-US": "Platform heels",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='platform heels', meta={})"
  },
  "c3.ankle_strap": {
    "ko-KR": "발목스트랩",
    "code": 919,
    "en-US": "Ankle straps",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='ankle strap', meta={})"
  },
  "c3.mule_heels": {
    "ko-KR": "뮬 구두",
    "code": 920,
    "en-US": "Mule heels",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='mule heels', meta={})"
  },
  "c3.clogs": {
    "ko-KR": "클로그",
    "code": 921,
    "en-US": "Clogs",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='clogs', meta={})"
  },
  "c3.espadrille": {
    "ko-KR": "에스파듀",
    "code": 922,
    "en-US": "Espadrilles",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='espadrille', meta={})"
  },
  "c3.mule_flats": {
    "ko-KR": "플랫 뮬",
    "code": 923,
    "en-US": "Mule flats",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='mule flats', meta={})"
  },
  "c3.brogue_shoes": {
    "ko-KR": "브로그 구두",
    "code": 924,
    "en-US": "Brogue shoes",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='brogue shoes', meta={})"
  },
  "c3.monkstraps": {
    "ko-KR": "몽크스트랩 구두",
    "code": 925,
    "en-US": "Monkstraps",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='monkstraps', meta={})"
  },
  "c3.sandal_heels": {
    "ko-KR": "샌들 구두",
    "code": 926,
    "en-US": "Sandal heels",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='sandal heels', meta={})"
  },
  "c3.sports_sandals": {
    "ko-KR": "스포츠 샌들",
    "code": 927,
    "en-US": "Sports sandals",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='sports sandals', meta={})"
  },
  "c3.slides": {
    "ko-KR": "슬리퍼",
    "code": 928,
    "en-US": "Slides",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='slides', meta={})"
  },
  "c3.mule_sneakers": {
    "ko-KR": "뮬 운동화",
    "code": 929,
    "en-US": "Mule sneakers",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='mule sneakers', meta={})"
  },
  "c3.soccer_shoes": {
    "ko-KR": "축구화",
    "code": 930,
    "en-US": "Soccer shoes",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='soccer shoes', meta={})"
  },
  "c3.golf_shoes": {
    "ko-KR": "골프화",
    "code": 931,
    "en-US": "Golf shoes",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='golf shoes', meta={})"
  },
  "c3.toe_shoes": {
    "ko-KR": "발레화",
    "code": 932,
    "en-US": "Ballet shoes",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='toe shoes', meta={})"
  },
  "c3.aqua_shoes": {
    "ko-KR": "아쿠아 슈즈",
    "code": 933,
    "en-US": "Aqua shoes",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='aqua shoes', meta={})"
  },
  "c3.snowboard_shoes": {
    "ko-KR": "스노우보드/스키 부츠",
    "code": 934,
    "en-US": "Snowboard shoes",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='snowboard shoes', meta={})"
  },
  "c3.backpacks": {
    "ko-KR": "백팩",
    "code": 951,
    "en-US": "Backpacks",
    "lv-LV": "-1",
    "ja-JP": "リュックサック"
  },
  "c3.suitcases": {
    "ko-KR": "캐리어",
    "code": 952,
    "en-US": "Suitcases",
    "lv-LV": "-1",
    "ja-JP": "スーツケース"
  },
  "c3.duffle_bags": {
    "ko-KR": "더플백",
    "code": 935,
    "en-US": "Duffle bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='duffle bags', meta={})"
  },
  "c3.golf_bags": {
    "ko-KR": "골프 가방",
    "code": 936,
    "en-US": "Golf bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='golf bags', meta={})"
  },
  "c3.boston_bags": {
    "ko-KR": "보스턴백",
    "code": 937,
    "en-US": "Boston bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='boston bags', meta={})"
  },
  "c3.drawstring_bags": {
    "ko-KR": "짐색",
    "code": 938,
    "en-US": "Drawstring bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='drawstring bags', meta={})"
  },
  "c3.pouch_bags": {
    "ko-KR": "파우치백",
    "code": 955,
    "en-US": "Pouch bags",
    "lv-LV": "-1",
    "ja-JP": "ポーチ·バッグ"
  },
  "c3.briefcases": {
    "ko-KR": "서류가방",
    "code": 958,
    "en-US": "Briefcases",
    "lv-LV": "-1",
    "ja-JP": "ブリーフケース"
  },
  "c3.clutch_bags": {
    "ko-KR": "클러치백",
    "code": 959,
    "en-US": "Clutch bags",
    "lv-LV": "-1",
    "ja-JP": "クラッチバッグ"
  },
  "c3.handbags": {
    "ko-KR": "핸드백",
    "code": 939,
    "en-US": "Hand bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='hand bags', meta={})"
  },
  "c3.bucket_bags": {
    "ko-KR": "버킷백",
    "code": 940,
    "en-US": "Bucket bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='bucket bags', meta={})"
  },
  "c3.hobo_bags": {
    "ko-KR": "호보백",
    "code": 941,
    "en-US": "Hobo bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='hobo bags', meta={})"
  },
  "c3.kellybags": {
    "ko-KR": "켈리백",
    "code": 942,
    "en-US": "Kelly bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='kelly bags', meta={})"
  },
  "c3.satchel_bags": {
    "ko-KR": "사첼백",
    "code": 943,
    "en-US": "Satchel bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='satchel bags', meta={})"
  },
  "c3.canteen_bags": {
    "ko-KR": "캔틴백",
    "code": 944,
    "en-US": "Canteen bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='canteen bags', meta={})"
  },
  "c3.messenger_bags": {
    "ko-KR": "메신저백",
    "code": 945,
    "en-US": "Messenger bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='messenger bags', meta={})"
  },
  "c3.cross_bags": {
    "ko-KR": "크로스백",
    "code": 946,
    "en-US": "Cross bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='cross bags', meta={})"
  },
  "c3.eco_bags": {
    "ko-KR": "에코백",
    "code": 947,
    "en-US": "Canvas bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='eco bags', meta={})"
  },
  "c3.fanny_packs": {
    "ko-KR": "힙색",
    "code": 956,
    "en-US": "Fanny packs",
    "lv-LV": "-1",
    "ja-JP": "ファニー·パック"
  },
  "c3.sling_bags": {
    "ko-KR": "슬링백",
    "code": 948,
    "en-US": "Sling bags",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='sling bags', meta={})"
  },
  "c3.arm_warmer": {
    "ko-KR": "팔토시",
    "code": 355,
    "en-US": "Arm warmer",
    "lv-LV": "-1",
    "ja-JP": "アームウォーマー"
  },
  "c3.beanies": {
    "ko-KR": "비니",
    "code": 356,
    "en-US": "Beanies",
    "lv-LV": "-1",
    "ja-JP": "ビーニー"
  },
  "c3.belts": {
    "ko-KR": "벨트",
    "code": 357,
    "en-US": "Belts",
    "lv-LV": "-1",
    "ja-JP": "ベルト"
  },
  "c3.berets": {
    "ko-KR": "베레모",
    "code": 358,
    "en-US": "Berets",
    "lv-LV": "-1",
    "ja-JP": "ベレット"
  },
  "c3.bifold_wallets": {
    "ko-KR": "반지갑",
    "code": 359,
    "en-US": "Bifold wallets",
    "lv-LV": "-1",
    "ja-JP": "二つ折り財布"
  },
  "c3.bowtie": {
    "ko-KR": "보타이/나비넥타이",
    "code": 360,
    "en-US": "Bowtie",
    "lv-LV": "-1",
    "ja-JP": "蝶ネクタイ"
  },
  "c3.bracelets_or_anklets": {
    "ko-KR": "팔찌/발찌",
    "code": 361,
    "en-US": "Bracelets or anklets",
    "lv-LV": "-1",
    "ja-JP": "腕輪"
  },
  "c3.bucket_hats": {
    "ko-KR": "버킷모자",
    "code": 362,
    "en-US": "Bucket hats",
    "lv-LV": "-1",
    "ja-JP": "バケット·ハット"
  },
  "c3.business_card_holder": {
    "ko-KR": "명함지갑",
    "code": 363,
    "en-US": "Business card holder",
    "lv-LV": "-1",
    "ja-JP": "名刺入れ"
  },
  "c3.caps_or_snapbacks": {
    "ko-KR": "야구모자/스냅백",
    "code": 364,
    "en-US": "Caps/Snapbacks",
    "lv-LV": "-1",
    "ja-JP": "キャップまたはスナップバック"
  },
  "c3.card_holder": {
    "ko-KR": "카드지갑",
    "code": 365,
    "en-US": "Card holder",
    "lv-LV": "-1",
    "ja-JP": "カードホルダー"
  },
  "c3.coin_purse": {
    "ko-KR": "동전지갑",
    "code": 366,
    "en-US": "Coin purse",
    "lv-LV": "-1",
    "ja-JP": "小銭入れ"
  },
  "c3.cufflinks": {
    "ko-KR": "커프링크스",
    "code": 367,
    "en-US": "Cufflinks",
    "lv-LV": "-1",
    "ja-JP": "カフスリンク"
  },
  "c3.earrings": {
    "ko-KR": "귀걸이",
    "code": 368,
    "en-US": "Earrings",
    "lv-LV": "-1",
    "ja-JP": "イヤリング"
  },
  "c3.eye_glasses": {
    "ko-KR": "안경",
    "code": 369,
    "en-US": "Eye glasses",
    "lv-LV": "-1",
    "ja-JP": "眼鏡"
  },
  "c3.fedora_or_floppy_hat": {
    "ko-KR": "페도라/플로피햇",
    "code": 370,
    "en-US": "Fedora/Floppy hats",
    "lv-LV": "-1",
    "ja-JP": "フェドラまたはフロッピーハット"
  },
  "c3.finger_gloves": {
    "ko-KR": "손가락장갑",
    "code": 371,
    "en-US": "Finger gloves",
    "lv-LV": "-1",
    "ja-JP": "指手袋"
  },
  "c3.fingerless_gloves": {
    "ko-KR": "반장갑",
    "code": 372,
    "en-US": "Fingerless gloves",
    "lv-LV": "-1",
    "ja-JP": "指のない手袋"
  },
  "c3.high_top_shoes": {
    "ko-KR": "하이탑 운동화",
    "code": 50318,
    "en-US": "High top shoes",
    "lv-LV": "373",
    "ja-JP": "ハイトップ·シューズ"
  },
  "c3.long_wallets": {
    "ko-KR": "장지갑",
    "code": 374,
    "en-US": "Long wallets",
    "lv-LV": "-1",
    "ja-JP": "長財布"
  },
  "c3.mittens": {
    "ko-KR": "벙어리장갑",
    "code": 375,
    "en-US": "Mittens",
    "lv-LV": "-1",
    "ja-JP": "ミトン"
  },
  "c3.money_clips": {
    "ko-KR": "머니클립",
    "code": 376,
    "en-US": "Money clips",
    "lv-LV": "-1",
    "ja-JP": "マネークリップ"
  },
  "c3.muffler": {
    "ko-KR": "목도리",
    "code": 377,
    "en-US": "Muffler",
    "lv-LV": "-1",
    "ja-JP": "マフラー"
  },
  "c3.necklaces": {
    "ko-KR": "목걸이",
    "code": 378,
    "en-US": "Necklaces",
    "lv-LV": "-1",
    "ja-JP": "ネックレス"
  },
  "c3.necktie": {
    "ko-KR": "넥타이",
    "code": 379,
    "en-US": "Necktie",
    "lv-LV": "-1",
    "ja-JP": "ネクタイ"
  },
  "c3.necktie_pin": {
    "ko-KR": "넥타이핀",
    "code": 380,
    "en-US": "Necktie pin",
    "lv-LV": "-1",
    "ja-JP": "ネクタイピン"
  },
  "c3.rings": {
    "ko-KR": "반지",
    "code": 381,
    "en-US": "Rings",
    "lv-LV": "-1",
    "ja-JP": "呼び出し音"
  },
  "c3.scarf": {
    "ko-KR": "스카프",
    "code": 382,
    "en-US": "Scarf",
    "lv-LV": "-1",
    "ja-JP": "スカーフ"
  },
  "c3.socks": {
    "ko-KR": "양말",
    "code": 383,
    "en-US": "Socks",
    "lv-LV": "-1",
    "ja-JP": "靴下"
  },
  "c3.suncaps": {
    "ko-KR": "썬캡",
    "code": 384,
    "en-US": "Suncaps",
    "lv-LV": "-1",
    "ja-JP": "サンキャップ"
  },
  "c3.sunglasses": {
    "ko-KR": "썬글라스",
    "code": 385,
    "en-US": "Sunglasses",
    "lv-LV": "-1",
    "ja-JP": "サングラス"
  },
  "c3.tights": {
    "ko-KR": "타이즈",
    "code": 386,
    "en-US": "Tights",
    "lv-LV": "-1",
    "ja-JP": "タイツ"
  },
  "c3.top_vests": {
    "ko-KR": "조끼",
    "code": 387,
    "en-US": "Vests",
    "lv-LV": "-1",
    "ja-JP": "ベストベスト"
  },
  "c3.watches": {
    "ko-KR": "손목시계",
    "code": 388,
    "en-US": "Watches",
    "lv-LV": "-1",
    "ja-JP": "腕時計"
  },
  "c3.water_leggings": {
    "ko-KR": "수영레깅스",
    "code": 389,
    "en-US": "Water leggings",
    "lv-LV": "-1",
    "ja-JP": "ウォーターレギンス"
  },
  "c3.hijabs": {
    "ko-KR": "히잡",
    "code": 887,
    "en-US": "Hijabs",
    "lv-LV": "-1",
    "ja-JP": "ヒジャブ"
  },
  "none.unknown": {
    "ko-KR": "알 수 없음",
    "code": -1,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "sense.unknown": {
    "ko-KR": "알 수 없음",
    "code": 50303,
    "en-US": "Unknown",
    "lv-LV": "305",
    "ja-JP": "知られざる"
  },
  "sense.unsupported": {
    "ko-KR": "미지원",
    "code": 319,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "sense.casual": {
    "ko-KR": "캐쥬얼",
    "code": 50295,
    "en-US": "Casual",
    "lv-LV": "31",
    "ja-JP": "何気ない"
  },
  "sense.chic": {
    "ko-KR": "시크",
    "code": 50296,
    "en-US": "Chic",
    "lv-LV": "32",
    "ja-JP": "シック"
  },
  "sense.feminine": {
    "ko-KR": "페미닌",
    "code": 50297,
    "en-US": "Feminine",
    "lv-LV": "33",
    "ja-JP": "女性らしい"
  },
  "sense.formal": {
    "ko-KR": "포멀",
    "code": 50298,
    "en-US": "Formal",
    "lv-LV": "34",
    "ja-JP": "形式ばった"
  },
  "sense.lovely": {
    "ko-KR": "러블리",
    "code": 50299,
    "en-US": "Lovely",
    "lv-LV": "35",
    "ja-JP": "美しい"
  },
  "sense.luxury": {
    "ko-KR": "럭셔리",
    "code": 50300,
    "en-US": "Luxury",
    "lv-LV": "36",
    "ja-JP": "ぜいたく"
  },
  "sense.sexy": {
    "ko-KR": "섹시",
    "code": 50301,
    "en-US": "Sexy",
    "lv-LV": "37",
    "ja-JP": "セクシー"
  },
  "sense.sportive": {
    "ko-KR": "스포티",
    "code": 50302,
    "en-US": "Sportive",
    "lv-LV": "38",
    "ja-JP": "スポーティ"
  },
  "pattern.unknown": {
    "ko-KR": "알 수 없음",
    "code": 306,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "pattern.none": {
    "ko-KR": "없음",
    "code": 50,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "pattern.unsupported": {
    "ko-KR": "미지원",
    "code": 320,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "pattern.check": {
    "ko-KR": "체크",
    "code": 51,
    "en-US": "Check",
    "lv-LV": "-1",
    "ja-JP": "王手"
  },
  "pattern.stripe": {
    "ko-KR": "줄무늬",
    "code": 52,
    "en-US": "Stripe",
    "lv-LV": "-1",
    "ja-JP": "ストライプ"
  },
  "pattern.flower": {
    "ko-KR": "꽃무늬",
    "code": 53,
    "en-US": "Flower",
    "lv-LV": "-1",
    "ja-JP": "花"
  },
  "pattern.dot": {
    "ko-KR": "땡땡이무늬",
    "code": 54,
    "en-US": "Dot",
    "lv-LV": "-1",
    "ja-JP": "点"
  },
  "pattern.camouflage": {
    "ko-KR": "캐머플러지/군대",
    "code": 55,
    "en-US": "Camouflage",
    "lv-LV": "-1",
    "ja-JP": "迷彩"
  },
  "pattern.leopard": {
    "ko-KR": "호피",
    "code": 50225,
    "en-US": "Leopard",
    "lv-LV": "56",
    "ja-JP": "ヒョウ"
  },
  "pattern.ethnic": {
    "ko-KR": "에스닉",
    "code": 57,
    "en-US": "Ethnic",
    "lv-LV": "-1",
    "ja-JP": "エスニック"
  },
  "pattern.paisley": {
    "ko-KR": "페이즐리",
    "code": 58,
    "en-US": "Paisley",
    "lv-LV": "-1",
    "ja-JP": "ペイズリー"
  },
  "pattern.geometry": {
    "ko-KR": "기하학무늬",
    "code": 59,
    "en-US": "Geometry",
    "lv-LV": "-1",
    "ja-JP": "幾何学"
  },
  "pattern.plain": {
    "ko-KR": "민무늬",
    "code": 60,
    "en-US": "Plain",
    "lv-LV": "-1",
    "ja-JP": "平明だ"
  },
  "pattern.print": {
    "ko-KR": "프린트",
    "code": 61,
    "en-US": "Print",
    "lv-LV": "-1",
    "ja-JP": "印刷物"
  },
  "pattern.animal": {
    "ko-KR": "동물무늬",
    "code": 837,
    "en-US": "Animal",
    "lv-LV": "-1",
    "ja-JP": "アニマル"
  },
  "pattern.weaving": {
    "ko-KR": "위빙/꼬임",
    "code": 871,
    "en-US": "Weaving",
    "lv-LV": "-1",
    "ja-JP": "製織"
  },
  "pattern.brand_logo": {
    "ko-KR": "브랜드로고",
    "code": 838,
    "en-US": "Brand logo",
    "lv-LV": "-1",
    "ja-JP": "ブランドロゴ"
  },
  "fabric.unknown": {
    "ko-KR": "알 수 없음",
    "code": 307,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "fabric.none": {
    "ko-KR": "없음",
    "code": 70,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "fabric.unsupported": {
    "ko-KR": "미지원",
    "code": 321,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "fabric.leather": {
    "ko-KR": "가죽",
    "code": 71,
    "en-US": "Leather",
    "lv-LV": "-1",
    "ja-JP": "革製のもの"
  },
  "fabric.cotton": {
    "ko-KR": "면",
    "code": 72,
    "en-US": "Cotton",
    "lv-LV": "-1",
    "ja-JP": "綿です。"
  },
  "fabric.knit/angora": {
    "ko-KR": "니트/앙고라",
    "code": 50004,
    "en-US": "Knit/angora",
    "lv-LV": "-1",
    "ja-JP": "編むアンゴラ"
  },
  "fabric.knit_or_angora": {
    "ko-KR": "니트/앙고라",
    "code": 73,
    "en-US": "Knit/Angora",
    "lv-LV": "-1",
    "ja-JP": "編んだオレンジ色"
  },
  "fabric.fur": {
    "ko-KR": "퍼",
    "code": 74,
    "en-US": "Fur",
    "lv-LV": "-1",
    "ja-JP": "毛皮"
  },
  "fabric.denim": {
    "ko-KR": "데님/청",
    "code": 75,
    "en-US": "Denim",
    "lv-LV": "-1",
    "ja-JP": "デニム"
  },
  "fabric.suede/velvet": {
    "ko-KR": "스웨이드/벨벳",
    "code": 50005,
    "en-US": "Suede/Velvet",
    "lv-LV": "-1",
    "ja-JP": "スエードスエード"
  },
  "fabric.suede_or_velvet": {
    "ko-KR": "스웨이드/벨벳",
    "code": 76,
    "en-US": "Suede/Velvet",
    "lv-LV": "-1",
    "ja-JP": "スエードまたはベルベット"
  },
  "fabric.chiffon/silk": {
    "ko-KR": "쉬폰/실크",
    "code": 50006,
    "en-US": "Chiffon/silk",
    "lv-LV": "-1",
    "ja-JP": "シフォンコーヒー"
  },
  "fabric.chiffon_or_silk": {
    "ko-KR": "쉬폰/실크",
    "code": 50118,
    "en-US": "Chiffon/Silk",
    "lv-LV": "77",
    "ja-JP": "シフォンまたは絹"
  },
  "fabric.linen": {
    "ko-KR": "리넨",
    "code": 78,
    "en-US": "Linen",
    "lv-LV": "-1",
    "ja-JP": "リンネル"
  },
  "fabric.lace/mesh": {
    "ko-KR": "레이스/매쉬",
    "code": 50007,
    "en-US": "Lace/mesh",
    "lv-LV": "-1",
    "ja-JP": "レースメッシュ"
  },
  "fabric.lace_or_mesh": {
    "ko-KR": "레이스/매쉬",
    "code": 79,
    "en-US": "Lace/Mesh",
    "lv-LV": "-1",
    "ja-JP": "レースまたはメッシュ"
  },
  "fabric.tweed": {
    "ko-KR": "트위드",
    "code": 80,
    "en-US": "Tweed",
    "lv-LV": "-1",
    "ja-JP": "ツイード"
  },
  "fabric.sequin/spangle": {
    "ko-KR": "시퀸/스팽글",
    "code": 50008,
    "en-US": "Sequin/spangle",
    "lv-LV": "-1",
    "ja-JP": "スパンコール"
  },
  "fabric.sequin_or_spangle": {
    "ko-KR": "시퀸/스팽글",
    "code": 81,
    "en-US": "Sequin/Spangle",
    "lv-LV": "-1",
    "ja-JP": "シークインまたはスパンコール"
  },
  "fabric.polyester": {
    "ko-KR": "폴리에스터",
    "code": 82,
    "en-US": "Polyester",
    "lv-LV": "-1",
    "ja-JP": "ポリエステル"
  },
  "fabric.wool": {
    "ko-KR": "울(모직)",
    "code": 531,
    "en-US": "Wool",
    "lv-LV": "-1",
    "ja-JP": "羊毛"
  },
  "fabric.straw_or_rattan": {
    "ko-KR": "밀짚/라탄",
    "code": 812,
    "en-US": "Straw/Rattan",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='straw or rattan', meta={})"
  },
  "fabric.enamel": {
    "ko-KR": "에나멜",
    "code": 807,
    "en-US": "Enamel",
    "lv-LV": "-1",
    "ja-JP": "エナメル質にする"
  },
  "fabric.silk": {
    "ko-KR": "실크",
    "code": 811,
    "en-US": "Silk",
    "lv-LV": "-1",
    "ja-JP": "シルク"
  },
  "fabric.corduroy": {
    "ko-KR": "코듀로이/골덴",
    "code": 525,
    "en-US": "Corduroy",
    "lv-LV": "-1",
    "ja-JP": "コーデュロイ"
  },
  "fabric.plastic": {
    "ko-KR": "플라스틱",
    "code": 809,
    "en-US": "Plastic",
    "lv-LV": "-1",
    "ja-JP": "プラスチック"
  },
  "fabric.wood": {
    "ko-KR": "우드",
    "code": 813,
    "en-US": "Wood",
    "lv-LV": "-1",
    "ja-JP": "木材"
  },
  "fabric.rubber": {
    "ko-KR": "고무",
    "code": 810,
    "en-US": "Rubber",
    "lv-LV": "-1",
    "ja-JP": "ゴム製品"
  },
  "fabric.chiffon": {
    "ko-KR": "쉬폰",
    "code": 806,
    "en-US": "Chiffon",
    "lv-LV": "-1",
    "ja-JP": "シフォン"
  },
  "fabric.metal": {
    "ko-KR": "메탈",
    "code": 808,
    "en-US": "Metal",
    "lv-LV": "-1",
    "ja-JP": "金属製の"
  },
  "fabric.fleece": {
    "ko-KR": "플리스",
    "code": 526,
    "en-US": "Fleece",
    "lv-LV": "-1",
    "ja-JP": "フリース"
  },
  "neckline.unknown": {
    "ko-KR": "알 수 없음",
    "code": 308,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "neckline.none": {
    "ko-KR": "없음",
    "code": 90,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "neckline.unsupported": {
    "ko-KR": "미지원",
    "code": 322,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "neckline.round_neck": {
    "ko-KR": "라운드넥",
    "code": 91,
    "en-US": "Round neck",
    "lv-LV": "-1",
    "ja-JP": "丸首"
  },
  "neckline.v_neck": {
    "ko-KR": "브이넥",
    "code": 92,
    "en-US": "V neck",
    "lv-LV": "-1",
    "ja-JP": "ネック"
  },
  "neckline.square_neck": {
    "ko-KR": "스퀘어넥",
    "code": 93,
    "en-US": "Square neck",
    "lv-LV": "-1",
    "ja-JP": "スクエアネック"
  },
  "neckline.turtle_neck": {
    "ko-KR": "터틀넥/목티",
    "code": 94,
    "en-US": "Turtle neck",
    "lv-LV": "-1",
    "ja-JP": "亀首"
  },
  "neckline.off_shoulder": {
    "ko-KR": "오프숄더",
    "code": 95,
    "en-US": "Off shoulder",
    "lv-LV": "-1",
    "ja-JP": "オフショルダー"
  },
  "neckline.one_shoulder": {
    "ko-KR": "원숄더",
    "code": 96,
    "en-US": "One shoulder",
    "lv-LV": "-1",
    "ja-JP": "片肩"
  },
  "neckline.henley_neck": {
    "ko-KR": "헨리넥",
    "code": 97,
    "en-US": "Henley neck",
    "lv-LV": "-1",
    "ja-JP": "ヘンリー·ネック"
  },
  "neckline.boat_neck": {
    "ko-KR": "보트넥",
    "code": 98,
    "en-US": "Boat neck",
    "lv-LV": "-1",
    "ja-JP": "ボートネック"
  },
  "neckline.halter_neck": {
    "ko-KR": "홀터넥",
    "code": 99,
    "en-US": "Halter neck",
    "lv-LV": "-1",
    "ja-JP": "ホルターネック"
  },
  "neckline.collar_neck": {
    "ko-KR": "카라넥",
    "code": 100,
    "en-US": "Collar neck",
    "lv-LV": "-1",
    "ja-JP": "襟首"
  },
  "neckline.cowl_neck": {
    "ko-KR": "카울넥",
    "code": 101,
    "en-US": "Cowl neck",
    "lv-LV": "-1",
    "ja-JP": "カウルネック"
  },
  "neckline.hood_collar": {
    "ko-KR": "후드",
    "code": 102,
    "en-US": "Hood collar",
    "lv-LV": "-1",
    "ja-JP": "フード·カラー"
  },
  "neckline.strapless": {
    "ko-KR": "스트랩리스",
    "code": 103,
    "en-US": "Strapless",
    "lv-LV": "-1",
    "ja-JP": "ストラップのない"
  },
  "neckline.off_or_one_shoulder": {
    "ko-KR": "오프/원 숄더",
    "code": 104,
    "en-US": "Off/One shoulder",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='off_or_one_shoulder', meta={})"
  },
  "length_of_tops.unknown": {
    "ko-KR": "알 수 없음",
    "code": 309,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "length_of_tops.none": {
    "ko-KR": "없음",
    "code": 110,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "length_of_tops.unsupported": {
    "ko-KR": "미지원",
    "code": 323,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "length_of_tops.crop": {
    "ko-KR": "크롭",
    "code": 111,
    "en-US": "Crop",
    "lv-LV": "-1",
    "ja-JP": "作物"
  },
  "length_of_tops.medium": {
    "ko-KR": "중간",
    "code": 112,
    "en-US": "Medium",
    "lv-LV": "-1",
    "ja-JP": "中程度"
  },
  "length_of_tops.long": {
    "ko-KR": "롱",
    "code": 113,
    "en-US": "Long",
    "lv-LV": "-1",
    "ja-JP": "長時間"
  },
  "length_of_onepiece.unknown": {
    "ko-KR": "알 수 없음",
    "code": 50220,
    "en-US": "Unknown",
    "lv-LV": "310",
    "ja-JP": "知られざる"
  },
  "length_of_onepiece.none": {
    "ko-KR": "없음",
    "code": 50219,
    "en-US": "None",
    "lv-LV": "115",
    "ja-JP": "なし"
  },
  "length_of_onepiece.unsupported": {
    "ko-KR": "미지원",
    "code": 50221,
    "en-US": "Unsupported",
    "lv-LV": "324",
    "ja-JP": "サポートされていない"
  },
  "length_of_onepiece.mini": {
    "ko-KR": "미니",
    "code": 50218,
    "en-US": "Mini",
    "lv-LV": "116",
    "ja-JP": "ミニ"
  },
  "length_of_onepiece.midi": {
    "ko-KR": "미디",
    "code": 50217,
    "en-US": "Midi",
    "lv-LV": "117",
    "ja-JP": "ミディ"
  },
  "length_of_onepiece.long": {
    "ko-KR": "롱",
    "code": 50216,
    "en-US": "Long",
    "lv-LV": "118",
    "ja-JP": "長時間"
  },
  "length_of_sleeve.unknown": {
    "ko-KR": "알 수 없음",
    "code": 311,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "length_of_sleeve.none": {
    "ko-KR": "없음",
    "code": 120,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "length_of_sleeve.unsupported": {
    "ko-KR": "미지원",
    "code": 325,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "length_of_sleeve.long_sleeve": {
    "ko-KR": "긴팔",
    "code": 121,
    "en-US": "Long sleeve",
    "lv-LV": "-1",
    "ja-JP": "長袖"
  },
  "length_of_sleeve.three_quarter_sleeve": {
    "ko-KR": "7부",
    "code": 122,
    "en-US": "Three quarter sleeve",
    "lv-LV": "-1",
    "ja-JP": "4分の3スリーブ"
  },
  "length_of_sleeve.short_sleeve": {
    "ko-KR": "반팔",
    "code": 123,
    "en-US": "Short sleeve",
    "lv-LV": "-1",
    "ja-JP": "半袖"
  },
  "length_of_sleeve.sleeveless": {
    "ko-KR": "민소매",
    "code": 124,
    "en-US": "Sleeveless",
    "lv-LV": "-1",
    "ja-JP": "袖なし"
  },
  "kind_of_sleeve.unknown": {
    "ko-KR": "알 수 없음",
    "code": 312,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "kind_of_sleeve.none": {
    "ko-KR": "없음",
    "code": 130,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "kind_of_sleeve.unsupported": {
    "ko-KR": "미지원",
    "code": 326,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "kind_of_sleeve.set-in_sleeve": {
    "ko-KR": "세트인 슬리브",
    "code": 50002,
    "en-US": "Set-in sleeve",
    "lv-LV": "-1",
    "ja-JP": "セットインスリーブ"
  },
  "kind_of_sleeve.setin_sleeve": {
    "ko-KR": "셋인 슬리브",
    "code": 131,
    "en-US": "Set-in sleeve",
    "lv-LV": "-1",
    "ja-JP": "袖に収める"
  },
  "kind_of_sleeve.drop_shoulder_sleeve": {
    "ko-KR": "드롭숄더",
    "code": 132,
    "en-US": "Drop shoulder sleeve",
    "lv-LV": "-1",
    "ja-JP": "ドロップ·ショルダー·スリーブ"
  },
  "kind_of_sleeve.raglan_sleeve": {
    "ko-KR": "라글란 슬리브",
    "code": 133,
    "en-US": "Raglan sleeve",
    "lv-LV": "-1",
    "ja-JP": "ラグランスリーブ"
  },
  "kind_of_sleeve.puff_sleeve": {
    "ko-KR": "퍼프 슬리브",
    "code": 134,
    "en-US": "Puff sleeve",
    "lv-LV": "-1",
    "ja-JP": "パフスリーブ"
  },
  "kind_of_sleeve.trumpet_sleeve": {
    "ko-KR": "트럼펫 슬리브",
    "code": 135,
    "en-US": "Trumpet sleeve",
    "lv-LV": "-1",
    "ja-JP": "トランペット·スリーブ"
  },
  "kind_of_sleeve.dolman_sleeve": {
    "ko-KR": "돌만 슬리브",
    "code": 136,
    "en-US": "Dolman sleeve",
    "lv-LV": "-1",
    "ja-JP": "ドルマンスリーブ"
  },
  "kind_of_sleeve.flutter_sleeve": {
    "ko-KR": "플러터 슬리브",
    "code": 137,
    "en-US": "Flutter sleeve",
    "lv-LV": "-1",
    "ja-JP": "フラッタースリーブ"
  },
  "shape_of_pants.unknown": {
    "ko-KR": "알 수 없음",
    "code": 313,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "shape_of_pants.none": {
    "ko-KR": "없음",
    "code": 150,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "shape_of_pants.unsupported": {
    "ko-KR": "미지원",
    "code": 327,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "shape_of_pants.skinny": {
    "ko-KR": "스키니",
    "code": 151,
    "en-US": "Skinny",
    "lv-LV": "-1",
    "ja-JP": "痩せた"
  },
  "shape_of_pants.straight": {
    "ko-KR": "스트레이트",
    "code": 152,
    "en-US": "Straight",
    "lv-LV": "-1",
    "ja-JP": "真っ直ぐ"
  },
  "shape_of_pants.boot-cut": {
    "ko-KR": "부츠컷",
    "code": 50003,
    "en-US": "Boot-cut",
    "lv-LV": "-1",
    "ja-JP": "ブーツカット"
  },
  "shape_of_pants.bootcut": {
    "ko-KR": "부츠컷",
    "code": 153,
    "en-US": "Boot-cut",
    "lv-LV": "-1",
    "ja-JP": "ブートカット"
  },
  "shape_of_pants.wide": {
    "ko-KR": "와이드",
    "code": 154,
    "en-US": "Wide",
    "lv-LV": "-1",
    "ja-JP": "幅が広い"
  },
  "shape_of_pants.baggy": {
    "ko-KR": "배기",
    "code": 155,
    "en-US": "Baggy",
    "lv-LV": "-1",
    "ja-JP": "だぶだぶの"
  },
  "shape_of_pants.leggings": {
    "ko-KR": "레깅스",
    "code": 156,
    "en-US": "Leggings",
    "lv-LV": "-1",
    "ja-JP": "レギンス"
  },
  "shape_of_skirts.unknown": {
    "ko-KR": "알 수 없음",
    "code": 314,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "shape_of_skirts.none": {
    "ko-KR": "없음",
    "code": 160,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "shape_of_skirts.unsupported": {
    "ko-KR": "미지원",
    "code": 328,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "shape_of_skirts.h_line": {
    "ko-KR": "H라인",
    "code": 161,
    "en-US": "H line",
    "lv-LV": "-1",
    "ja-JP": "hライン"
  },
  "shape_of_skirts.flare": {
    "ko-KR": "플레어",
    "code": 162,
    "en-US": "Flare",
    "lv-LV": "-1",
    "ja-JP": "フレア"
  },
  "shape_of_skirts.flare_or_bubble": {
    "ko-KR": "플레어",
    "code": 169,
    "en-US": "Flare",
    "lv-LV": "-1",
    "ja-JP": "フレア"
  },
  "shape_of_skirts.a_line": {
    "ko-KR": "A라인",
    "code": 163,
    "en-US": "A line",
    "lv-LV": "-1",
    "ja-JP": "一列"
  },
  "shape_of_skirts.pleats": {
    "ko-KR": "플리츠",
    "code": 164,
    "en-US": "Pleats",
    "lv-LV": "-1",
    "ja-JP": "プリーツ"
  },
  "shape_of_skirts.mermaid": {
    "ko-KR": "머메이드",
    "code": 165,
    "en-US": "Mermaid",
    "lv-LV": "-1",
    "ja-JP": "マーメイド"
  },
  "shape_of_skirts.wrap": {
    "ko-KR": "랩",
    "code": 166,
    "en-US": "Wrap",
    "lv-LV": "-1",
    "ja-JP": "包み込む"
  },
  "shape_of_skirts.tiered": {
    "ko-KR": "티어드/캉캉",
    "code": 167,
    "en-US": "Tiered",
    "lv-LV": "-1",
    "ja-JP": "階層化された"
  },
  "shape_of_skirts.asymmetrical": {
    "ko-KR": "언발란스",
    "code": 168,
    "en-US": "Asymmetrical",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='asymmetrical', meta={})"
  },
  "shape_of_dresses.unknown": {
    "ko-KR": "알 수 없음",
    "code": 50307,
    "en-US": "Unknown",
    "lv-LV": "315",
    "ja-JP": "知られざる"
  },
  "shape_of_dresses.none": {
    "ko-KR": "없음",
    "code": 50306,
    "en-US": "None",
    "lv-LV": "170",
    "ja-JP": "なし"
  },
  "shape_of_dresses.unsupported": {
    "ko-KR": "미지원",
    "code": 50308,
    "en-US": "Unsupported",
    "lv-LV": "329",
    "ja-JP": "サポートされていない"
  },
  "shape_of_dresses.h_line": {
    "ko-KR": "H라인",
    "code": 50305,
    "en-US": "H line",
    "lv-LV": "171",
    "ja-JP": "hライン"
  },
  "shape_of_dresses.a_line": {
    "ko-KR": "A라인",
    "code": 50304,
    "en-US": "A line",
    "lv-LV": "172",
    "ja-JP": "一列"
  },
  "shape_of_dresses.wrap": {
    "ko-KR": "랩",
    "code": 50309,
    "en-US": "Wrap",
    "lv-LV": "173",
    "ja-JP": "包み込む"
  },
  "color.unknown": {
    "ko-KR": "알 수 없음",
    "code": 316,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "color.unsupported": {
    "ko-KR": "미지원",
    "code": 330,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "color.black": {
    "ko-KR": "검정",
    "code": 181,
    "en-US": "Black",
    "lv-LV": "-1",
    "ja-JP": "黒"
  },
  "color.gray": {
    "ko-KR": "회색",
    "code": 182,
    "en-US": "Gray",
    "lv-LV": "-1",
    "ja-JP": "灰色の"
  },
  "color.silver": {
    "ko-KR": "실버",
    "code": 183,
    "en-US": "Silver",
    "lv-LV": "-1",
    "ja-JP": "銀色の"
  },
  "color.white": {
    "ko-KR": "흰색",
    "code": 184,
    "en-US": "White",
    "lv-LV": "-1",
    "ja-JP": "白"
  },
  "color.brown": {
    "ko-KR": "브라운",
    "code": 185,
    "en-US": "Brown",
    "lv-LV": "-1",
    "ja-JP": "茶色い"
  },
  "color.khaki": {
    "ko-KR": "카키",
    "code": 50321,
    "en-US": "Khaki",
    "lv-LV": "186",
    "ja-JP": "カーキ"
  },
  "color.navy": {
    "ko-KR": "남색",
    "code": 187,
    "en-US": "Navy",
    "lv-LV": "-1",
    "ja-JP": "海軍"
  },
  "color.orange": {
    "ko-KR": "오렌지",
    "code": 188,
    "en-US": "Orange",
    "lv-LV": "-1",
    "ja-JP": "オレンジ色の"
  },
  "color.yellow": {
    "ko-KR": "노랑",
    "code": 189,
    "en-US": "Yellow",
    "lv-LV": "-1",
    "ja-JP": "黄色"
  },
  "color.gold": {
    "ko-KR": "골드",
    "code": 190,
    "en-US": "Gold",
    "lv-LV": "-1",
    "ja-JP": "金貨"
  },
  "color.green": {
    "ko-KR": "초록",
    "code": 191,
    "en-US": "Green",
    "lv-LV": "-1",
    "ja-JP": "生い茂る"
  },
  "color.skyblue": {
    "ko-KR": "하늘색",
    "code": 192,
    "en-US": "Skyblue",
    "lv-LV": "-1",
    "ja-JP": "スカイブルー"
  },
  "color.blue": {
    "ko-KR": "파랑",
    "code": 193,
    "en-US": "Blue",
    "lv-LV": "-1",
    "ja-JP": "青"
  },
  "color.purple": {
    "ko-KR": "보라",
    "code": 194,
    "en-US": "Purple",
    "lv-LV": "-1",
    "ja-JP": "紫色の"
  },
  "color.pink": {
    "ko-KR": "핑크",
    "code": 195,
    "en-US": "Pink",
    "lv-LV": "-1",
    "ja-JP": "ピンク"
  },
  "color.red": {
    "ko-KR": "빨강",
    "code": 196,
    "en-US": "Red",
    "lv-LV": "-1",
    "ja-JP": "赤"
  },
  "color.beige": {
    "ko-KR": "베이지",
    "code": 197,
    "en-US": "Beige",
    "lv-LV": "-1",
    "ja-JP": "ベージュ"
  },
  "color.multi": {
    "ko-KR": "멀티",
    "code": 391,
    "en-US": "Multi",
    "lv-LV": "-1",
    "ja-JP": "複数の"
  },
  "color.wine": {
    "ko-KR": "와인",
    "code": 854,
    "en-US": "Wine",
    "lv-LV": "-1",
    "ja-JP": "ワイン"
  },
  "color.beige_or_lightbrown": {
    "ko-KR": "베이지/연갈색",
    "code": 856,
    "en-US": "Beige/Light brown",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='beige_or_lightbrown', meta={})"
  },
  "color.olive": {
    "ko-KR": "카키",
    "code": 848,
    "en-US": "Olive",
    "lv-LV": "-1",
    "ja-JP": "オリーブ色"
  },
  "color.lavender": {
    "ko-KR": "라벤더(연보라)",
    "code": 853,
    "en-US": "Lavender",
    "lv-LV": "-1",
    "ja-JP": "ラベンダー色"
  },
  "color.mint": {
    "ko-KR": "민트",
    "code": 847,
    "en-US": "Mint",
    "lv-LV": "-1",
    "ja-JP": "ミント"
  },
  "color.light_pink": {
    "ko-KR": "연핑크",
    "code": 851,
    "en-US": "Light pink",
    "lv-LV": "-1",
    "ja-JP": "薄いピンク色"
  },
  "color.clear": {
    "ko-KR": "투명",
    "code": 860,
    "en-US": "Clear",
    "lv-LV": "-1",
    "ja-JP": "澄ます"
  },
  "color.hot_pink": {
    "ko-KR": "핫핑크",
    "code": 852,
    "en-US": "Hot pink",
    "lv-LV": "-1",
    "ja-JP": "ホットピンク"
  },
  "age_group.adults": {
    "ko-KR": "성인",
    "code": 341,
    "en-US": "Adults",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='adults', meta={})"
  },
  "age_group.seniors": {
    "ko-KR": "중장년",
    "code": 340,
    "en-US": "Seniors",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='seniors', meta={})"
  },
  "age_group.young_adults": {
    "ko-KR": "청소년",
    "code": 339,
    "en-US": "Young adults",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='young_adults', meta={})"
  },
  "age_group.unrelated": {
    "ko-KR": "나이불문",
    "code": 342,
    "en-US": "Unrelated",
    "lv-LV": "-1",
    "ja-JP": "関係のない"
  },
  "age_group.unknown": {
    "ko-KR": "알 수 없음",
    "code": 338,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "decoration.beads_or_jewelry": {
    "ko-KR": "비즈/쥬얼리",
    "code": 392,
    "en-US": "Beads/Jewelry",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='beads_or_jewelry', meta={})"
  },
  "decoration.buckle_or_belted": {
    "ko-KR": "버클/벨트",
    "code": 393,
    "en-US": "Buckle/Belted",
    "lv-LV": "-1",
    "ja-JP": "バックルまたはベルトを締める"
  },
  "decoration.button": {
    "ko-KR": "단추",
    "code": 394,
    "en-US": "Button",
    "lv-LV": "-1",
    "ja-JP": "ボタンを押す"
  },
  "decoration.chain": {
    "ko-KR": "체인",
    "code": 395,
    "en-US": "Chain",
    "lv-LV": "-1",
    "ja-JP": "鎖"
  },
  "decoration.embroidery": {
    "ko-KR": "자수",
    "code": 396,
    "en-US": "Embroidery",
    "lv-LV": "-1",
    "ja-JP": "刺繍"
  },
  "decoration.none": {
    "ko-KR": "없음",
    "code": 397,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "decoration.ribbon": {
    "ko-KR": "리본",
    "code": 399,
    "en-US": "Ribbon",
    "lv-LV": "-1",
    "ja-JP": "リボン"
  },
  "decoration.stud_or_metal": {
    "ko-KR": "스터드(징)/메탈",
    "code": 400,
    "en-US": "Stud/Metal",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='stud or metal', meta={})"
  },
  "decoration.tassel_or_fringe": {
    "ko-KR": "태슬/프린지",
    "code": 402,
    "en-US": "Tassel/Fringe",
    "lv-LV": "-1",
    "ja-JP": "房飾りまたは縁"
  },
  "decoration.unknown": {
    "ko-KR": "알 수 없음",
    "code": 403,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "decoration.zipper": {
    "ko-KR": "지퍼",
    "code": 404,
    "en-US": "Zipper",
    "lv-LV": "-1",
    "ja-JP": "ジッパー"
  },
  "decoration.fur": {
    "ko-KR": "퍼/털",
    "code": 799,
    "en-US": "Fur",
    "lv-LV": "-1",
    "ja-JP": "毛皮"
  },
  "decoration.keyring_or_strap": {
    "ko-KR": "키링/스트랩",
    "code": 801,
    "en-US": "Keyring/Strap",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='keyring_or_strap', meta={})"
  },
  "decoration.flower": {
    "ko-KR": "꽃",
    "code": 798,
    "en-US": "Flower",
    "lv-LV": "-1",
    "ja-JP": "花"
  },
  "decoration.punch": {
    "ko-KR": "펀칭",
    "code": 803,
    "en-US": "Punch",
    "lv-LV": "-1",
    "ja-JP": "パンチ"
  },
  "decoration.quilt": {
    "ko-KR": "퀼트/누빔",
    "code": 804,
    "en-US": "Quilt",
    "lv-LV": "-1",
    "ja-JP": "キルト"
  },
  "detail.destroyed": {
    "ko-KR": "디스트로이드",
    "code": 513,
    "en-US": "Destroyed",
    "lv-LV": "-1",
    "ja-JP": "破壊された"
  },
  "detail.drape": {
    "ko-KR": "드레이프",
    "code": 514,
    "en-US": "Drape",
    "lv-LV": "-1",
    "ja-JP": "ドレープ"
  },
  "detail.none": {
    "ko-KR": "없음",
    "code": 516,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "detail.shirring_or_ruffle": {
    "ko-KR": "셔링/러플",
    "code": 517,
    "en-US": "Shirring/Ruffle",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='shirring_or_ruffle', meta={})"
  },
  "detail.slit": {
    "ko-KR": "슬릿",
    "code": 518,
    "en-US": "Slit",
    "lv-LV": "-1",
    "ja-JP": "スリット"
  },
  "detail.unknown": {
    "ko-KR": "알 수 없음",
    "code": 519,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "detail.anorak": {
    "ko-KR": "아노락",
    "code": 515,
    "en-US": "Anorak",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='anorak', meta={})"
  },
  "direction.back": {
    "ko-KR": "뒤",
    "code": 520,
    "en-US": "Back",
    "lv-LV": "-1",
    "ja-JP": "バック"
  },
  "direction.front": {
    "ko-KR": "앞",
    "code": 521,
    "en-US": "Front",
    "lv-LV": "-1",
    "ja-JP": "正面"
  },
  "direction.side": {
    "ko-KR": "옆(측면)",
    "code": 522,
    "en-US": "Side",
    "lv-LV": "-1",
    "ja-JP": "側面"
  },
  "direction.unknown": {
    "ko-KR": "알 수 없음",
    "code": 523,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "direction.sole": {
    "ko-KR": "밑창",
    "code": 863,
    "en-US": "Sole",
    "lv-LV": "-1",
    "ja-JP": "唯一の"
  },
  "fit.boxy": {
    "ko-KR": "박시핏(오버핏)",
    "code": 623,
    "en-US": "Boxy",
    "lv-LV": "-1",
    "ja-JP": "箱のような"
  },
  "fit.slim": {
    "ko-KR": "슬림핏",
    "code": 624,
    "en-US": "Slim",
    "lv-LV": "-1",
    "ja-JP": "ほっそりした"
  },
  "fit.standard": {
    "ko-KR": "기본핏",
    "code": 625,
    "en-US": "Standard",
    "lv-LV": "-1",
    "ja-JP": "基準"
  },
  "fit.unknown": {
    "ko-KR": "알 수 없음",
    "code": 626,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "frame_of_eyewear.half_rim": {
    "ko-KR": "반테",
    "code": 627,
    "en-US": "Half rim",
    "lv-LV": "-1",
    "ja-JP": "ハーフリム"
  },
  "frame_of_eyewear.metal": {
    "ko-KR": "metal",
    "code": 628,
    "en-US": "Metal",
    "lv-LV": "413",
    "ja-JP": "金属製の"
  },
  "frame_of_eyewear.plastic": {
    "ko-KR": "plastic",
    "code": 629,
    "en-US": "Plastic",
    "lv-LV": "539",
    "ja-JP": "プラスチック"
  },
  "frame_of_eyewear.rimless": {
    "ko-KR": "무테",
    "code": 630,
    "en-US": "Rimless",
    "lv-LV": "-1",
    "ja-JP": "縁なし"
  },
  "heel_height.high": {
    "ko-KR": "높음",
    "code": 631,
    "en-US": "High",
    "lv-LV": "-1",
    "ja-JP": "高い"
  },
  "heel_height.low": {
    "ko-KR": "낮음",
    "code": 632,
    "en-US": "Low",
    "lv-LV": "-1",
    "ja-JP": "低劣だ"
  },
  "heel_height.middle": {
    "ko-KR": "중간",
    "code": 633,
    "en-US": "Middle",
    "lv-LV": "-1",
    "ja-JP": "中央にある"
  },
  "heel_height.unknown": {
    "ko-KR": "알 수 없음",
    "code": 634,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "heel_thickness.none": {
    "ko-KR": "없음",
    "code": 635,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "heel_thickness.thick": {
    "ko-KR": "굵음",
    "code": 636,
    "en-US": "Thick",
    "lv-LV": "-1",
    "ja-JP": "濃い"
  },
  "heel_thickness.thin": {
    "ko-KR": "얇음",
    "code": 637,
    "en-US": "Thin",
    "lv-LV": "-1",
    "ja-JP": "薄い"
  },
  "heel_thickness.unknown": {
    "ko-KR": "알 수 없음",
    "code": 638,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "kind_of_image.item": {
    "ko-KR": "상품",
    "code": 639,
    "en-US": "Item",
    "lv-LV": "-1",
    "ja-JP": "項目"
  },
  "kind_of_image.mannequin": {
    "ko-KR": "마네킹",
    "code": 640,
    "en-US": "Mannequin",
    "lv-LV": "-1",
    "ja-JP": "マネキン"
  },
  "kind_of_image.person": {
    "ko-KR": "사람",
    "code": 641,
    "en-US": "Person",
    "lv-LV": "-1",
    "ja-JP": "人"
  },
  "kind_of_image.unknown": {
    "ko-KR": "알 수 없음",
    "code": 642,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "kind_of_shoes_toes.open_toe": {
    "ko-KR": "오픈토",
    "code": 643,
    "en-US": "Open toe",
    "lv-LV": "-1",
    "ja-JP": "開放爪先"
  },
  "kind_of_shoes_toes.pointed_toe": {
    "ko-KR": "포인트토(뾰족)",
    "code": 644,
    "en-US": "Pointed toe",
    "lv-LV": "-1",
    "ja-JP": "尖った足指"
  },
  "kind_of_shoes_toes.round_toe": {
    "ko-KR": "라운드토",
    "code": 645,
    "en-US": "Round toe",
    "lv-LV": "-1",
    "ja-JP": "丸いつま先"
  },
  "kind_of_shoes_toes.square_toe": {
    "ko-KR": "스퀘어토",
    "code": 646,
    "en-US": "Square toe",
    "lv-LV": "-1",
    "ja-JP": "正方形のつま先"
  },
  "kind_of_shoes_toes.unknown": {
    "ko-KR": "알 수 없음",
    "code": 647,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "length_of_socks_or_tights.crew_or_ankle": {
    "ko-KR": "크루(발목)",
    "code": 653,
    "en-US": "Crew/Ankle",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='crew_or_ankle', meta={})"
  },
  "length_of_socks_or_tights.invisible": {
    "ko-KR": "안보이는/덧신",
    "code": 654,
    "en-US": "Invisible",
    "lv-LV": "-1",
    "ja-JP": "不可視できない"
  },
  "length_of_socks_or_tights.lowcut": {
    "ko-KR": "로우컷",
    "code": 656,
    "en-US": "Lowcut",
    "lv-LV": "-1",
    "ja-JP": "ローカット"
  },
  "length_of_socks_or_tights.knee_or_overknee": {
    "ko-KR": "무릎/무릎위",
    "code": 657,
    "en-US": "Knee/Overknee",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='knee_or_overknee', meta={})"
  },
  "length_of_socks_or_tights.tights": {
    "ko-KR": "타이즈",
    "code": 658,
    "en-US": "Tights",
    "lv-LV": "-1",
    "ja-JP": "タイツ"
  },
  "occasion.date": {
    "ko-KR": "데이트",
    "code": 660,
    "en-US": "Date",
    "lv-LV": "-1",
    "ja-JP": "日付"
  },
  "occasion.unknown": {
    "ko-KR": "알 수 없음",
    "code": 669,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "occasion.business_or_formal": {
    "ko-KR": "비즈니스/포멀",
    "code": 864,
    "en-US": "Business/Formal",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='business_or_formal', meta={})"
  },
  "occasion.outdoor": {
    "ko-KR": "야외/아웃도어",
    "code": 867,
    "en-US": "Outdoor",
    "lv-LV": "-1",
    "ja-JP": "屋外の"
  },
  "occasion.casual_or_social": {
    "ko-KR": "캐쥬얼",
    "code": 869,
    "en-US": "Casual/Social",
    "lv-LV": "-1",
    "ja-JP": "何気ない、または社会的な"
  },
  "occasion.club_or_nightout": {
    "ko-KR": "클럽",
    "code": 868,
    "en-US": "Club/Nightout",
    "lv-LV": "-1",
    "ja-JP": "クラブかナイトクラブか"
  },
  "occasion.home_or_loungewear": {
    "ko-KR": "홈/라운지웨어",
    "code": 870,
    "en-US": "Home/Loungewear",
    "lv-LV": "-1",
    "ja-JP": "ホームウェアまたはラウンジ"
  },
  "occasion.gym": {
    "ko-KR": "헬스장",
    "code": 866,
    "en-US": "Gym",
    "lv-LV": "-1",
    "ja-JP": "体育館"
  },
  "pocket.change_pocket": {
    "ko-KR": "체인지포켓",
    "code": 740,
    "en-US": "Change pocket",
    "lv-LV": "-1",
    "ja-JP": "小銭入れ"
  },
  "pocket.flap_pocket": {
    "ko-KR": "플랩포켓",
    "code": 741,
    "en-US": "Flap pocket",
    "lv-LV": "-1",
    "ja-JP": "フラップポケット"
  },
  "pocket.jetted_pocket": {
    "ko-KR": "제트포켓",
    "code": 742,
    "en-US": "Jetted pocket",
    "lv-LV": "-1",
    "ja-JP": "噴射ポケット"
  },
  "pocket.none": {
    "ko-KR": "없음",
    "code": 743,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "pocket.out_pocket": {
    "ko-KR": "아웃포켓",
    "code": 744,
    "en-US": "Out pocket",
    "lv-LV": "-1",
    "ja-JP": "アウトポケット"
  },
  "pocket.unknown": {
    "ko-KR": "알 수 없음",
    "code": 745,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "pocket.vertical_pocket": {
    "ko-KR": "버티컬포켓",
    "code": 746,
    "en-US": "Vertical pocket",
    "lv-LV": "-1",
    "ja-JP": "縦ポケット"
  },
  "rise.high_waist": {
    "ko-KR": "하이웨이스트",
    "code": 747,
    "en-US": "High waist",
    "lv-LV": "-1",
    "ja-JP": "ハイウエスト"
  },
  "rise.low_waist": {
    "ko-KR": "로우웨이스트",
    "code": 748,
    "en-US": "Low waist",
    "lv-LV": "-1",
    "ja-JP": "ローウエスト"
  },
  "rise.mid_waist": {
    "ko-KR": "미드웨이스트",
    "code": 749,
    "en-US": "Mid waist",
    "lv-LV": "-1",
    "ja-JP": "中腰"
  },
  "rise.unknown": {
    "ko-KR": "알 수 없음",
    "code": 750,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "season.autumn": {
    "ko-KR": "가을",
    "code": 751,
    "en-US": "Autumn",
    "lv-LV": "-1",
    "ja-JP": "秋の"
  },
  "season.spring": {
    "ko-KR": "봄",
    "code": 752,
    "en-US": "Spring",
    "lv-LV": "-1",
    "ja-JP": "スプリング"
  },
  "season.summer": {
    "ko-KR": "여름",
    "code": 753,
    "en-US": "Summer",
    "lv-LV": "-1",
    "ja-JP": "夏期"
  },
  "season.winter": {
    "ko-KR": "겨울",
    "code": 754,
    "en-US": "Winter",
    "lv-LV": "-1",
    "ja-JP": "冬"
  },
  "season.none": {
    "ko-KR": "사계절",
    "code": 756,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "season.unknown": {
    "ko-KR": "알 수 없음",
    "code": 757,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "shape_of_eyewear.aviator": {
    "ko-KR": "에비에이터",
    "code": 763,
    "en-US": "Aviator",
    "lv-LV": "-1",
    "ja-JP": "飛行士"
  },
  "shape_of_eyewear.cat_eye": {
    "ko-KR": "캣아이",
    "code": 764,
    "en-US": "Cat eye",
    "lv-LV": "-1",
    "ja-JP": "キャットアイ"
  },
  "shape_of_eyewear.heart": {
    "ko-KR": "하트",
    "code": 765,
    "en-US": "Heart",
    "lv-LV": "-1",
    "ja-JP": "ハート"
  },
  "shape_of_eyewear.oval": {
    "ko-KR": "타원",
    "code": 766,
    "en-US": "Oval",
    "lv-LV": "-1",
    "ja-JP": "卵形の"
  },
  "shape_of_eyewear.pantos": {
    "ko-KR": "판토스",
    "code": 767,
    "en-US": "Pantos",
    "lv-LV": "-1",
    "ja-JP": "パントス"
  },
  "shape_of_eyewear.round": {
    "ko-KR": "원형",
    "code": 768,
    "en-US": "Round",
    "lv-LV": "-1",
    "ja-JP": "円い"
  },
  "shape_of_eyewear.square": {
    "ko-KR": "사각형",
    "code": 769,
    "en-US": "Square",
    "lv-LV": "-1",
    "ja-JP": "四角い"
  },
  "shape_of_eyewear.unknown": {
    "ko-KR": "알 수 없음",
    "code": 770,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "style.elegant_or_luxury": {
    "ko-KR": "럭셔리",
    "code": 784,
    "en-US": "Elegant/Luxury",
    "lv-LV": "-1",
    "ja-JP": "優雅で贅沢なさま"
  },
  "style.feminine_or_romantic": {
    "ko-KR": "페미닌/여성스러운",
    "code": 785,
    "en-US": "Feminine/Romantic",
    "lv-LV": "-1",
    "ja-JP": "女性的またはロマンチックな"
  },
  "style.mannish_or_tomboy": {
    "ko-KR": "남성적인/톰보이",
    "code": 786,
    "en-US": "Mannish/Tomboy",
    "lv-LV": "-1",
    "ja-JP": "男っぽいかおてんばな男"
  },
  "style.punk_or_rock": {
    "ko-KR": "펑크/락",
    "code": 788,
    "en-US": "Punk/Rock",
    "lv-LV": "-1",
    "ja-JP": "パンクかロックか"
  },
  "style.retro_or_vintage": {
    "ko-KR": "레트로",
    "code": 789,
    "en-US": "Retro/Vintage",
    "lv-LV": "-1",
    "ja-JP": "レトロまたは年代物"
  },
  "style.sexy": {
    "ko-KR": "섹시",
    "code": 790,
    "en-US": "Sexy",
    "lv-LV": "-1",
    "ja-JP": "セクシー"
  },
  "style.unknown": {
    "ko-KR": "알 수 없음",
    "code": 792,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "style.preppy_or_school": {
    "ko-KR": "스쿨/프레피",
    "code": 881,
    "en-US": "Preppy/School",
    "lv-LV": "-1",
    "ja-JP": "プレッピーまたは学校"
  },
  "style.bohemian_or_ethnic": {
    "ko-KR": "보헤미안",
    "code": 880,
    "en-US": "Bohemian/Ethnic",
    "lv-LV": "-1",
    "ja-JP": "ボヘミアンまたはエスニック"
  },
  "style.sporty_or_athleisure": {
    "ko-KR": "스포티",
    "code": 883,
    "en-US": "Sporty/Athleisure",
    "lv-LV": "-1",
    "ja-JP": "スポーティーかスポーツの娯楽"
  },
  "style.casual_or_girlnextdoor": {
    "ko-KR": "캐쥬얼",
    "code": 877,
    "en-US": "Casual/Girl next door",
    "lv-LV": "-1",
    "ja-JP": "隣の女の子または女の子"
  },
  "style.artsy_or_vibrant": {
    "ko-KR": "아트",
    "code": 882,
    "en-US": "Artsy/Vibrant",
    "lv-LV": "-1",
    "ja-JP": "芸術的であるか活気に満ちた"
  },
  "style.chic_or_trendy": {
    "ko-KR": "시크/트렌디",
    "code": 879,
    "en-US": "Chic/Trendy",
    "lv-LV": "-1",
    "ja-JP": "シックまたはトレンディーな"
  },
  "style.basic_or_minimal": {
    "ko-KR": "미니멀/심플",
    "code": 878,
    "en-US": "Basic/Minimal",
    "lv-LV": "-1",
    "ja-JP": "基本または最小"
  },
  "wear_or_not.not_wear": {
    "ko-KR": "미착용",
    "code": 793,
    "en-US": "Not wear",
    "lv-LV": "-1",
    "ja-JP": "着ない"
  },
  "wear_or_not.wear": {
    "ko-KR": "착용",
    "code": 794,
    "en-US": "Wear",
    "lv-LV": "-1",
    "ja-JP": "磨耗"
  },
  "fastener.belt_or_buckle": {
    "ko-KR": "벨트/버클",
    "code": 814,
    "en-US": "Belt/Buckle",
    "lv-LV": "-1",
    "ja-JP": "ベルトまたはバックル"
  },
  "fastener.button_or_snap": {
    "ko-KR": "단추/스냅",
    "code": 815,
    "en-US": "Button/Snap",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='button_or_snap', meta={})"
  },
  "fastener.none": {
    "ko-KR": "없음",
    "code": 816,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "fastener.strap": {
    "ko-KR": "끈",
    "code": 818,
    "en-US": "Strap",
    "lv-LV": "-1",
    "ja-JP": "革ひも"
  },
  "fastener.tie": {
    "ko-KR": "매듭",
    "code": 819,
    "en-US": "Tie",
    "lv-LV": "-1",
    "ja-JP": "引き分けにする"
  },
  "fastener.unknown": {
    "ko-KR": "알 수 없음",
    "code": 820,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "fastener.velcro": {
    "ko-KR": "벨크로(찍찍이)",
    "code": 821,
    "en-US": "Velcro",
    "lv-LV": "-1",
    "ja-JP": "マジックテープ"
  },
  "fastener.zipper": {
    "ko-KR": "지퍼",
    "code": 822,
    "en-US": "Zipper",
    "lv-LV": "-1",
    "ja-JP": "ジッパー"
  },
  "leather.cow_leather": {
    "ko-KR": "소가죽",
    "code": 824,
    "en-US": "Cow leather",
    "lv-LV": "-1",
    "ja-JP": "その他の"
  },
  "leather.animal_leather": {
    "ko-KR": "동물무늬 가죽",
    "code": 825,
    "en-US": "Animal leather",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='animal_leather', meta={})"
  },
  "leather.suede_leather": {
    "ko-KR": "스웨이드 가죽",
    "code": 826,
    "en-US": "Suede Leather",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='suede_leather', meta={})"
  },
  "leather.none": {
    "ko-KR": "없음",
    "code": 827,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "length_of_bottoms.floor": {
    "ko-KR": "플로어/땅에닿음",
    "code": 828,
    "en-US": "Floor",
    "lv-LV": "-1",
    "ja-JP": "床に置く"
  },
  "length_of_bottoms.long": {
    "ko-KR": "롱",
    "code": 829,
    "en-US": "Long",
    "lv-LV": "-1",
    "ja-JP": "長い"
  },
  "length_of_bottoms.midi": {
    "ko-KR": "미디",
    "code": 831,
    "en-US": "Midi",
    "lv-LV": "-1",
    "ja-JP": "ミディ"
  },
  "length_of_bottoms.mini": {
    "ko-KR": "미니",
    "code": 832,
    "en-US": "Mini",
    "lv-LV": "-1",
    "ja-JP": "ミニ"
  },
  "length_of_bottoms.none": {
    "ko-KR": "없음",
    "code": 833,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "length_of_bottoms.unknown": {
    "ko-KR": "알 수 없음",
    "code": 834,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "length_of_bottoms.unsupported": {
    "ko-KR": "미지원",
    "code": 835,
    "en-US": "Unsupported",
    "lv-LV": "-1",
    "ja-JP": "サポートされていない"
  },
  "state_of_fastener.closed": {
    "ko-KR": "닫혀있음",
    "code": 873,
    "en-US": "Closed",
    "lv-LV": "-1",
    "ja-JP": "閉ざした"
  },
  "state_of_fastener.none": {
    "ko-KR": "없음",
    "code": 876,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "state_of_fastener.opened": {
    "ko-KR": "열려있음",
    "code": 874,
    "en-US": "Opened",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='opened', meta={})"
  },
  "state_of_fastener.unknown": {
    "ko-KR": "알 수 없음",
    "code": 875,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "wash.dark": {
    "ko-KR": "진한",
    "code": 886,
    "en-US": "Dark",
    "lv-LV": "-1",
    "ja-JP": "暗鬱"
  },
  "wash.light": {
    "ko-KR": "연한",
    "code": 884,
    "en-US": "Light",
    "lv-LV": "-1",
    "ja-JP": "軽い"
  },
  "wash.medium": {
    "ko-KR": "중간",
    "code": 885,
    "en-US": "Medium",
    "lv-LV": "-1",
    "ja-JP": "中程度"
  },
  "wash.none": {
    "ko-KR": "없음",
    "code": 830,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "type_of_pants.leggings": {
    "ko-KR": "레깅스",
    "code": 171,
    "en-US": "Leggings",
    "lv-LV": "-1",
    "ja-JP": "レギンス"
  },
  "type_of_pants.slacks_or_dresspants": {
    "ko-KR": "슬랙스/정장바지",
    "code": 172,
    "en-US": "Slacks/Dress pants",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='slacks_or_dresspants', meta={})"
  },
  "type_of_pants.jeans": {
    "ko-KR": "청바지",
    "code": 173,
    "en-US": "Jeans",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='jeans', meta={})"
  },
  "type_of_pants.sweatpants": {
    "ko-KR": "츄리닝바지",
    "code": 174,
    "en-US": "Sweat pants",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='sweatpants', meta={})"
  },
  "type_of_pants.cargopants": {
    "ko-KR": "카고바지",
    "code": 175,
    "en-US": "Cargo pants",
    "lv-LV": "-1",
    "ja-JP": "PropertyTuple(data='cargopants', meta={})"
  },
  "type_of_pants.none": {
    "ko-KR": "없음",
    "code": 176,
    "en-US": "None",
    "lv-LV": "-1",
    "ja-JP": "なし"
  },
  "type_of_pants.unknown": {
    "ko-KR": "알 수 없음",
    "code": 177,
    "en-US": "Unknown",
    "lv-LV": "-1",
    "ja-JP": "知られざる"
  },
  "317": "gender.unknown",
  "536870912": "gender.female",
  "1073741824": "gender.male",
  "1610612736": "gender.unisex",
  "805306368": "gender.child_female",
  "1342177280": "gender.child_male",
  "1879048192": "gender.child_unisex",
  "334": "gender.unsupported",
  "0": "unknown",
  "302": "c1.unknown",
  "333": "c1.unsupported",
  "201": "c1.tops",
  "202": "c1.bottoms",
  "203": "c1.onepiece",
  "204": "c1.bags",
  "205": "c1.shoes",
  "200": "c1.face",
  "888": "c1.headwear",
  "343": "c1.accessories",
  "303": "c2.unknown",
  "332": "c2.unsupported",
  "206": "c2.outerwears",
  "207": "c2.tops",
  "50320": "c2.underwear",
  "50319": "c2.swimsuits",
  "208": "c2.underwear_tops",
  "50322": "c2.swimsuits_tops",
  "210": "c2.pants",
  "211": "c2.skirts",
  "212": "c2.underwear_bottoms",
  "50323": "c2.swimsuits_bottoms",
  "214": "c2.onepiece",
  "949": "c2.dresses",
  "889": "c2.jumpsuits_overallpants",
  "215": "c2.underwear_onepiece",
  "50324": "c2.swimsuits_onepiece",
  "217": "c2.boots",
  "218": "c2.heels_pumps",
  "219": "c2.loafers",
  "220": "c2.sandals",
  "221": "c2.sneakers",
  "222": "c2.sports_shoes",
  "950": "c2.dress_shoes",
  "890": "c2.indoor_shoes",
  "957": "c2.flats",
  "223": "c2.totebags",
  "960": "c2.shoulder_crossbags",
  "224": "c2.shoulder_cross_bags",
  "225": "c2.clutch_bags",
  "226": "c2.pouch_bags",
  "227": "c2.backpacks",
  "228": "c2.briefcases",
  "229": "c2.suitcases",
  "230": "c2.fanny_pack",
  "231": "c2.sports_bags",
  "891": "c2.handbags",
  "344": "c2.belts",
  "345": "c2.gloves",
  "346": "c2.hats",
  "347": "c2.inners",
  "348": "c2.jewelry",
  "349": "c2.necktie",
  "350": "c2.scarf_or_muffler",
  "351": "c2.socks_or_tights",
  "352": "c2.sunglasses_or_eye_glasses",
  "353": "c2.wallets",
  "354": "c2.watches",
  "842": "c2.swimsuit_bottoms",
  "841": "c2.swimsuit_tops",
  "843": "c2.swimsuit_onepiece",
  "318": "c3.none",
  "304": "c3.unknown",
  "331": "c3.unsupported",
  "232": "c3.cardigans",
  "233": "c3.jumpers",
  "234": "c3.coats",
  "235": "c3.jackets",
  "236": "c3.vests",
  "892": "c3.cape_coats",
  "893": "c3.trench_coats",
  "894": "c3.rider_or_leatherjacket",
  "895": "c3.blazer_or_suitjackets",
  "896": "c3.denim_jackets",
  "897": "c3.trucker_jackets",
  "898": "c3.aviator_jackets",
  "899": "c3.bomber_or_blousonjacket",
  "900": "c3.down_jackets",
  "901": "c3.parkas",
  "902": "c3.field_jackets",
  "903": "c3.sports_outer",
  "904": "c3.furjacket_coats",
  "905": "c3.windbreakers",
  "237": "c3.tshirts",
  "238": "c3.sweatshirts",
  "239": "c3.hoodies",
  "240": "c3.knitwear",
  "241": "c3.blouses",
  "242": "c3.shirts",
  "243": "c3.bustiers",
  "244": "c3.bras",
  "245": "c3.camisoles_slips",
  "246": "c3.running_shirts",
  "247": "c3.bikini_tops",
  "248": "c3.rash_guards",
  "249": "c3.long_pants",
  "250": "c3.capri_pants",
  "251": "c3.short_pants",
  "252": "c3.long_skirts",
  "253": "c3.midi_skirts",
  "254": "c3.mini_skirts",
  "255": "c3.panties",
  "256": "c3.drawers",
  "257": "c3.underskirts",
  "258": "c3.bikini_bottoms",
  "259": "c3.swim_briefs",
  "260": "c3.swim_trunks",
  "261": "c3.dresses",
  "906": "c3.long_dresses",
  "907": "c3.midi_dresses",
  "908": "c3.mini_dresses",
  "909": "c3.overall_pants",
  "310": "c3.long_overall_pants",
  "315": "c3.midi_overall_pants",
  "324": "c3.mini_overall_pants",
  "910": "c3.ballgown",
  "262": "c3.jumpsuits",
  "300": "c3.long_jumpsuits",
  "301": "c3.midi_jumpsuits",
  "305": "c3.mini_jumpsuits",
  "263": "c3.yukatas_kimonos",
  "264": "c3.bodysuits",
  "265": "c3.onepiece_swimsuits",
  "266": "c3.monokinis",
  "267": "c3.wetsuits",
  "268": "c3.booties",
  "269": "c3.ankle_boots",
  "270": "c3.walkers",
  "271": "c3.long_boots",
  "272": "c3.half_boots",
  "273": "c3.rain_boots",
  "274": "c3.boots",
  "275": "c3.pumps",
  "276": "c3.stiletto_heels",
  "277": "c3.wedge_heels",
  "278": "c3.open_toed_heels",
  "279": "c3.sling_back_shoes",
  "50000": "c3.maryjane_strap_heels",
  "280": "c3.maryjane",
  "281": "c3.flat_shoes",
  "282": "c3.loafers",
  "283": "c3.bloafers",
  "284": "c3.oxford_shoes",
  "285": "c3.flat_sandals",
  "286": "c3.platform_sandals",
  "287": "c3.wedge_sandals",
  "288": "c3.gladiator_sandals",
  "50001": "c3.strap_sandals",
  "289": "c3.strap_sandal_heels",
  "290": "c3.slippers",
  "291": "c3.flip_flops",
  "292": "c3.mules",
  "293": "c3.hightop_shoes",
  "294": "c3.sneakers",
  "295": "c3.slipon_shoes",
  "296": "c3.dress_shoes",
  "297": "c3.boat_shoes",
  "298": "c3.sandals",
  "299": "c3.hiking_shoes",
  "911": "c3.ankleboots_or_booties",
  "912": "c3.mid_calf_boots",
  "913": "c3.uggs",
  "914": "c3.padding_boots",
  "915": "c3.cowboy_boots",
  "916": "c3.chukka_boots",
  "917": "c3.chelsea_boots",
  "918": "c3.platform_heels",
  "919": "c3.ankle_strap",
  "920": "c3.mule_heels",
  "921": "c3.clogs",
  "922": "c3.espadrille",
  "923": "c3.mule_flats",
  "924": "c3.brogue_shoes",
  "925": "c3.monkstraps",
  "926": "c3.sandal_heels",
  "927": "c3.sports_sandals",
  "928": "c3.slides",
  "929": "c3.mule_sneakers",
  "930": "c3.soccer_shoes",
  "931": "c3.golf_shoes",
  "932": "c3.toe_shoes",
  "933": "c3.aqua_shoes",
  "934": "c3.snowboard_shoes",
  "951": "c3.backpacks",
  "952": "c3.suitcases",
  "935": "c3.duffle_bags",
  "936": "c3.golf_bags",
  "937": "c3.boston_bags",
  "938": "c3.drawstring_bags",
  "955": "c3.pouch_bags",
  "958": "c3.briefcases",
  "959": "c3.clutch_bags",
  "939": "c3.handbags",
  "940": "c3.bucket_bags",
  "941": "c3.hobo_bags",
  "942": "c3.kellybags",
  "943": "c3.satchel_bags",
  "944": "c3.canteen_bags",
  "945": "c3.messenger_bags",
  "946": "c3.cross_bags",
  "947": "c3.eco_bags",
  "956": "c3.fanny_packs",
  "948": "c3.sling_bags",
  "355": "c3.arm_warmer",
  "356": "c3.beanies",
  "357": "c3.belts",
  "358": "c3.berets",
  "359": "c3.bifold_wallets",
  "360": "c3.bowtie",
  "361": "c3.bracelets_or_anklets",
  "362": "c3.bucket_hats",
  "363": "c3.business_card_holder",
  "364": "c3.caps_or_snapbacks",
  "365": "c3.card_holder",
  "366": "c3.coin_purse",
  "367": "c3.cufflinks",
  "368": "c3.earrings",
  "369": "c3.eye_glasses",
  "370": "c3.fedora_or_floppy_hat",
  "371": "c3.finger_gloves",
  "372": "c3.fingerless_gloves",
  "50318": "c3.high_top_shoes",
  "374": "c3.long_wallets",
  "375": "c3.mittens",
  "376": "c3.money_clips",
  "377": "c3.muffler",
  "378": "c3.necklaces",
  "379": "c3.necktie",
  "380": "c3.necktie_pin",
  "381": "c3.rings",
  "382": "c3.scarf",
  "383": "c3.socks",
  "384": "c3.suncaps",
  "385": "c3.sunglasses",
  "386": "c3.tights",
  "387": "c3.top_vests",
  "388": "c3.watches",
  "389": "c3.water_leggings",
  "887": "c3.hijabs",
  "-1": "none.unknown",
  "50303": "sense.unknown",
  "319": "sense.unsupported",
  "50295": "sense.casual",
  "50296": "sense.chic",
  "50297": "sense.feminine",
  "50298": "sense.formal",
  "50299": "sense.lovely",
  "50300": "sense.luxury",
  "50301": "sense.sexy",
  "50302": "sense.sportive",
  "306": "pattern.unknown",
  "50": "pattern.none",
  "320": "pattern.unsupported",
  "51": "pattern.check",
  "52": "pattern.stripe",
  "53": "pattern.flower",
  "54": "pattern.dot",
  "55": "pattern.camouflage",
  "50225": "pattern.leopard",
  "57": "pattern.ethnic",
  "58": "pattern.paisley",
  "59": "pattern.geometry",
  "60": "pattern.plain",
  "61": "pattern.print",
  "837": "pattern.animal",
  "871": "pattern.weaving",
  "838": "pattern.brand_logo",
  "307": "fabric.unknown",
  "70": "fabric.none",
  "321": "fabric.unsupported",
  "71": "fabric.leather",
  "72": "fabric.cotton",
  "50004": "fabric.knit/angora",
  "73": "fabric.knit_or_angora",
  "74": "fabric.fur",
  "75": "fabric.denim",
  "50005": "fabric.suede/velvet",
  "76": "fabric.suede_or_velvet",
  "50006": "fabric.chiffon/silk",
  "50118": "fabric.chiffon_or_silk",
  "78": "fabric.linen",
  "50007": "fabric.lace/mesh",
  "79": "fabric.lace_or_mesh",
  "80": "fabric.tweed",
  "50008": "fabric.sequin/spangle",
  "81": "fabric.sequin_or_spangle",
  "82": "fabric.polyester",
  "531": "fabric.wool",
  "812": "fabric.straw_or_rattan",
  "807": "fabric.enamel",
  "811": "fabric.silk",
  "525": "fabric.corduroy",
  "809": "fabric.plastic",
  "813": "fabric.wood",
  "810": "fabric.rubber",
  "806": "fabric.chiffon",
  "808": "fabric.metal",
  "526": "fabric.fleece",
  "308": "neckline.unknown",
  "90": "neckline.none",
  "322": "neckline.unsupported",
  "91": "neckline.round_neck",
  "92": "neckline.v_neck",
  "93": "neckline.square_neck",
  "94": "neckline.turtle_neck",
  "95": "neckline.off_shoulder",
  "96": "neckline.one_shoulder",
  "97": "neckline.henley_neck",
  "98": "neckline.boat_neck",
  "99": "neckline.halter_neck",
  "100": "neckline.collar_neck",
  "101": "neckline.cowl_neck",
  "102": "neckline.hood_collar",
  "103": "neckline.strapless",
  "104": "neckline.off_or_one_shoulder",
  "309": "length_of_tops.unknown",
  "110": "length_of_tops.none",
  "323": "length_of_tops.unsupported",
  "111": "length_of_tops.crop",
  "112": "length_of_tops.medium",
  "113": "length_of_tops.long",
  "50220": "length_of_onepiece.unknown",
  "50219": "length_of_onepiece.none",
  "50221": "length_of_onepiece.unsupported",
  "50218": "length_of_onepiece.mini",
  "50217": "length_of_onepiece.midi",
  "50216": "length_of_onepiece.long",
  "311": "length_of_sleeve.unknown",
  "120": "length_of_sleeve.none",
  "325": "length_of_sleeve.unsupported",
  "121": "length_of_sleeve.long_sleeve",
  "122": "length_of_sleeve.three_quarter_sleeve",
  "123": "length_of_sleeve.short_sleeve",
  "124": "length_of_sleeve.sleeveless",
  "312": "kind_of_sleeve.unknown",
  "130": "kind_of_sleeve.none",
  "326": "kind_of_sleeve.unsupported",
  "50002": "kind_of_sleeve.set-in_sleeve",
  "131": "kind_of_sleeve.setin_sleeve",
  "132": "kind_of_sleeve.drop_shoulder_sleeve",
  "133": "kind_of_sleeve.raglan_sleeve",
  "134": "kind_of_sleeve.puff_sleeve",
  "135": "kind_of_sleeve.trumpet_sleeve",
  "136": "kind_of_sleeve.dolman_sleeve",
  "137": "kind_of_sleeve.flutter_sleeve",
  "313": "shape_of_pants.unknown",
  "150": "shape_of_pants.none",
  "327": "shape_of_pants.unsupported",
  "151": "shape_of_pants.skinny",
  "152": "shape_of_pants.straight",
  "50003": "shape_of_pants.boot-cut",
  "153": "shape_of_pants.bootcut",
  "154": "shape_of_pants.wide",
  "155": "shape_of_pants.baggy",
  "156": "shape_of_pants.leggings",
  "314": "shape_of_skirts.unknown",
  "160": "shape_of_skirts.none",
  "328": "shape_of_skirts.unsupported",
  "161": "shape_of_skirts.h_line",
  "162": "shape_of_skirts.flare",
  "169": "shape_of_skirts.flare_or_bubble",
  "163": "shape_of_skirts.a_line",
  "164": "shape_of_skirts.pleats",
  "165": "shape_of_skirts.mermaid",
  "166": "shape_of_skirts.wrap",
  "167": "shape_of_skirts.tiered",
  "168": "shape_of_skirts.asymmetrical",
  "50307": "shape_of_dresses.unknown",
  "50306": "shape_of_dresses.none",
  "50308": "shape_of_dresses.unsupported",
  "50305": "shape_of_dresses.h_line",
  "50304": "shape_of_dresses.a_line",
  "50309": "shape_of_dresses.wrap",
  "316": "color.unknown",
  "330": "color.unsupported",
  "181": "color.black",
  "182": "color.gray",
  "183": "color.silver",
  "184": "color.white",
  "185": "color.brown",
  "50321": "color.khaki",
  "187": "color.navy",
  "188": "color.orange",
  "189": "color.yellow",
  "190": "color.gold",
  "191": "color.green",
  "192": "color.skyblue",
  "193": "color.blue",
  "194": "color.purple",
  "195": "color.pink",
  "196": "color.red",
  "197": "color.beige",
  "391": "color.multi",
  "854": "color.wine",
  "856": "color.beige_or_lightbrown",
  "848": "color.olive",
  "853": "color.lavender",
  "847": "color.mint",
  "851": "color.light_pink",
  "860": "color.clear",
  "852": "color.hot_pink",
  "341": "age_group.adults",
  "340": "age_group.seniors",
  "339": "age_group.young_adults",
  "342": "age_group.unrelated",
  "338": "age_group.unknown",
  "392": "decoration.beads_or_jewelry",
  "393": "decoration.buckle_or_belted",
  "394": "decoration.button",
  "395": "decoration.chain",
  "396": "decoration.embroidery",
  "397": "decoration.none",
  "399": "decoration.ribbon",
  "400": "decoration.stud_or_metal",
  "402": "decoration.tassel_or_fringe",
  "403": "decoration.unknown",
  "404": "decoration.zipper",
  "799": "decoration.fur",
  "801": "decoration.keyring_or_strap",
  "798": "decoration.flower",
  "803": "decoration.punch",
  "804": "decoration.quilt",
  "513": "detail.destroyed",
  "514": "detail.drape",
  "516": "detail.none",
  "517": "detail.shirring_or_ruffle",
  "518": "detail.slit",
  "519": "detail.unknown",
  "515": "detail.anorak",
  "520": "direction.back",
  "521": "direction.front",
  "522": "direction.side",
  "523": "direction.unknown",
  "863": "direction.sole",
  "623": "fit.boxy",
  "624": "fit.slim",
  "625": "fit.standard",
  "626": "fit.unknown",
  "627": "frame_of_eyewear.half_rim",
  "628": "frame_of_eyewear.metal",
  "629": "frame_of_eyewear.plastic",
  "630": "frame_of_eyewear.rimless",
  "631": "heel_height.high",
  "632": "heel_height.low",
  "633": "heel_height.middle",
  "634": "heel_height.unknown",
  "635": "heel_thickness.none",
  "636": "heel_thickness.thick",
  "637": "heel_thickness.thin",
  "638": "heel_thickness.unknown",
  "639": "kind_of_image.item",
  "640": "kind_of_image.mannequin",
  "641": "kind_of_image.person",
  "642": "kind_of_image.unknown",
  "643": "kind_of_shoes_toes.open_toe",
  "644": "kind_of_shoes_toes.pointed_toe",
  "645": "kind_of_shoes_toes.round_toe",
  "646": "kind_of_shoes_toes.square_toe",
  "647": "kind_of_shoes_toes.unknown",
  "653": "length_of_socks_or_tights.crew_or_ankle",
  "654": "length_of_socks_or_tights.invisible",
  "656": "length_of_socks_or_tights.lowcut",
  "657": "length_of_socks_or_tights.knee_or_overknee",
  "658": "length_of_socks_or_tights.tights",
  "660": "occasion.date",
  "669": "occasion.unknown",
  "864": "occasion.business_or_formal",
  "867": "occasion.outdoor",
  "869": "occasion.casual_or_social",
  "868": "occasion.club_or_nightout",
  "870": "occasion.home_or_loungewear",
  "866": "occasion.gym",
  "740": "pocket.change_pocket",
  "741": "pocket.flap_pocket",
  "742": "pocket.jetted_pocket",
  "743": "pocket.none",
  "744": "pocket.out_pocket",
  "745": "pocket.unknown",
  "746": "pocket.vertical_pocket",
  "747": "rise.high_waist",
  "748": "rise.low_waist",
  "749": "rise.mid_waist",
  "750": "rise.unknown",
  "751": "season.autumn",
  "752": "season.spring",
  "753": "season.summer",
  "754": "season.winter",
  "756": "season.none",
  "757": "season.unknown",
  "763": "shape_of_eyewear.aviator",
  "764": "shape_of_eyewear.cat_eye",
  "765": "shape_of_eyewear.heart",
  "766": "shape_of_eyewear.oval",
  "767": "shape_of_eyewear.pantos",
  "768": "shape_of_eyewear.round",
  "769": "shape_of_eyewear.square",
  "770": "shape_of_eyewear.unknown",
  "784": "style.elegant_or_luxury",
  "785": "style.feminine_or_romantic",
  "786": "style.mannish_or_tomboy",
  "788": "style.punk_or_rock",
  "789": "style.retro_or_vintage",
  "790": "style.sexy",
  "792": "style.unknown",
  "881": "style.preppy_or_school",
  "880": "style.bohemian_or_ethnic",
  "883": "style.sporty_or_athleisure",
  "877": "style.casual_or_girlnextdoor",
  "882": "style.artsy_or_vibrant",
  "879": "style.chic_or_trendy",
  "878": "style.basic_or_minimal",
  "793": "wear_or_not.not_wear",
  "794": "wear_or_not.wear",
  "814": "fastener.belt_or_buckle",
  "815": "fastener.button_or_snap",
  "816": "fastener.none",
  "818": "fastener.strap",
  "819": "fastener.tie",
  "820": "fastener.unknown",
  "821": "fastener.velcro",
  "822": "fastener.zipper",
  "824": "leather.cow_leather",
  "825": "leather.animal_leather",
  "826": "leather.suede_leather",
  "827": "leather.none",
  "828": "length_of_bottoms.floor",
  "829": "length_of_bottoms.long",
  "831": "length_of_bottoms.midi",
  "832": "length_of_bottoms.mini",
  "833": "length_of_bottoms.none",
  "834": "length_of_bottoms.unknown",
  "835": "length_of_bottoms.unsupported",
  "873": "state_of_fastener.closed",
  "876": "state_of_fastener.none",
  "874": "state_of_fastener.opened",
  "875": "state_of_fastener.unknown",
  "886": "wash.dark",
  "884": "wash.light",
  "885": "wash.medium",
  "830": "wash.none",
  "171": "type_of_pants.leggings",
  "172": "type_of_pants.slacks_or_dresspants",
  "173": "type_of_pants.jeans",
  "174": "type_of_pants.sweatpants",
  "175": "type_of_pants.cargopants",
  "176": "type_of_pants.none",
  "177": "type_of_pants.unknown"
};

export const CATEGORY = {
  1: {
    "type": "normal",
    "sub_categories": [
    {"id": 261, "str": "dresses"},
    {"id": 262, "str": "jumpsuits"}
    ],
    "str": "onepiece"
  },
  2: {
    "type": "normal",
    "sub_categories": [
    {"id": 249, "str": "long pants"},
    {"id": 250, "str": "capri pants"},
    {"id": 251, "str": "short pants"}
    ],
    "str": "pants"
  },
  4: {
    "type": "normal",
    "sub_categories": [],
    "str": "short pants"
  },
  8: {
    "type": "normal",
    "sub_categories": [
    {"id": 252, "str": "long skirts"},
    {"id": 253, "str": "midi skirts"},
    {"id": 254, "str": "mini skirts"}
    ],
    "str": "skirts"
  },
  16: {
    "type": "normal",
    "sub_categories": [
    {"id": 237, "str": "tshirts"},
    {"id": 238, "str": "sweatshirts"},
    {"id": 239, "str": "hoodies"},
    {"id": 240, "str": "knits"},
    {"id": 241, "str": "blouses"},
    {"id": 242, "str": "shirts"},
    {"id": 243, "str": "bustiers"}],
    "str": "tops"
  },
  32: {
    "type": "normal",
    "sub_categories": [
    {"id": 232, "str": "cardigans"},
    {"id": 233, "str": "jumpers"},
    {"id": 234, "str": "coats"},
    {"id": 235, "str": "jackets"},
    {"id": 236, "str": "vests"}
    ],
    "str": "outerwears"
  },
  64: {
    "type": "underwear",
    "sub_categories": [
    {"id": 244, "str": "bras"},
    {"id": 245, "str": "camisoles/slips"},
    {"id": 246, "str": "running shirts"}
    ],
    "str": "underwear tops"
  },
  128: {
    "type": "underwear",
    "sub_categories": [
    {"id": 255, "str": "panties"},
    {"id": 256, "str": "drawers"},
    {"id": 257, "str": "underskirts"}
    ],
    "str": "underwear bottoms"
  },
  256: {
    "type": "underwear",
    "sub_categories": [
    {"id": 264, "str": "bodysuits"}
    ],
    "str": "underwear onepiece"
  },
  512: {
    "type": "swimsuits",
    "sub_categories": [
    {"id": 247, "str": "bikini tops"},
    {"id": 248, "str": "rash guards"}
    ],
    "str": "swimsuits tops"
  },
  1024: {
    "type": "swimsuits",
    "sub_categories": [
    {"id": 258, "str": "bikini bottoms"},
    {"id": 259, "str": "swim briefs"},
    {"id": 260, "str": "swim trunks"}
    ],
    "str": "swimsuits bottoms"
  },
  2048: {
    "type": "swimsuits",
    "sub_categories": [
    {"id": 265, "str": "onepiece swimsuits"},
    {"id": 266, "str": "monokinis"},
    {"id": 267, "str": "wetsuits"}
    ],
    "str": "swimsuits onepiece"
  },
  4096: {
    "type": "bags",
    "sub_categories": [],
    "str": "tote bags"
  },
  8192: {
    "type": "bags",
    "sub_categories": [],
    "str": "shoulder/cross bags"
  },
  16384: {
    "type": "bags",
    "sub_categories": [],
    "str": "backpacks"
  },
  32768: {
    "type": "bags",
    "sub_categories": [],
    "str": "bumbags"
  },
  65536: {
    "type": "bags",
    "sub_categories": [],
    "str": "clutch bags"
  },
  131072: {
    "type": "bags",
    "sub_categories": [],
    "str": "pouch bags"
  },
  262144: {
    "type": "bags",
    "sub_categories": [],
    "str": "briefcases"
  },
  524288: {
    "type": "bags",
    "sub_categories": [],
    "str": "sports bags"
  },
  1048576: {
    "type": "bags",
    "sub_categories": [],
    "str": "suitcases"
  },
  2097152: {
    "type": "shoes",
    "sub_categories": [
    {"id": 268, "str": "booties"},
    {"id": 269, "str": "ankle boots"},
    {"id": 270, "str": "walkers"},
    {"id": 271, "str": "long boots"},
    {"id": 272, "str": "half boots"},
    {"id": 273, "str": "rain boots"},
    {"id": 274, "str": "boots"}
    ],
    "str": "boots"
  },
  4194304: {
    "type": "shoes",
    "sub_categories": [
    {"id": 275, "str": "pumps"},
    {"id": 276, "str": "stiletto heels"},
    {"id": 277, "str": "wedge heels"},
    {"id": 278, "str": "toe open heels"},
    {"id": 279, "str": "sling back shoes"},
    {"id": 280, "str": "maryjane strap heels"}
    ],
    "str": "heels/pumps"
  },
  8388608: {
    "type": "shoes",
    "sub_categories": [
    {"id": 281, "str": "flat shoes"},
    {"id": 282, "str": "loafers"},
    {"id": 283, "str": "bloafers"},
    {"id": 284, "str": "oxford shoes"},
    {"id": 296, "str": "dress shoes"},
    {"id": 297, "str": "boat shoes"}
    ],
    "str": "loafers"
  },
  16777216: {
    "type": "shoes",
    "sub_categories": [
    {"id": 285, "str": "flat sandals"},
    {"id": 286, "str": "platform sandals"},
    {"id": 287, "str": "wedge sandals"},
    {"id": 288, "str": "gladiator sandals"},
    {"id": 289, "str": "strap sandals"},
    {"id": 290, "str": "slippers"},
    {"id": 291, "str": "flip flops"},
    {"id": 292, "str": "mules"},
    {"id": 298, "str": "sandals"}
    ],
    "str": "sandals"
  },
  33554432: {
    "type": "shoes",
    "sub_categories": [
    {"id": 293, "str": "hightop shoes"},
    {"id": 294, "str": "sneakers"},
    {"id": 295, "str": "slip on shoes"}
    ],
    "str": "sneakers"
  },
  67108864: {
    "type": "shoes",
    "sub_categories": [
    {"id": 299, "str": "tracking shoes"}
    ],
    "str": "sports shoes"
  }
};

export const ATTRIBUTE = {
  "sense": {
    "31": {
      "type": "sense",
      "en": "casual",
      "ko": "캐주얼"
    },
    "32": {
      "type": "sense",
      "en": "chic",
      "ko": "시크"
    },
    "33": {
      "type": "sense",
      "en": "feminine",
      "ko": "페미닌"
    },
    "34": {
      "type": "sense",
      "en": "formal",
      "ko": "포멀"
    },
    "35": {
      "type": "sense",
      "en": "lovely",
      "ko": "러블리"
    },
    "36": {
      "type": "sense",
      "en": "luxury",
      "ko": "럭셔리"
    },
    "37": {
      "type": "sense",
      "en": "sexy",
      "ko": "섹시"
    },
    "38": {
      "type": "sense",
      "en": "sportive",
      "ko": "스포티"
    }
  },
  "pattern": {
    "50": {
      "type": "pattern",
      "en": "none",
      "ko": "없음"
    },
    "51": {
      "type": "pattern",
      "en": "check",
      "ko": "체크"
    },
    "52": {
      "type": "pattern",
      "en": "stripe",
      "ko": "스트라이프"
    },
    "53": {
      "type": "pattern",
      "en": "flower",
      "ko": "꽃무늬"
    },
    "54": {
      "type": "pattern",
      "en": "dot",
      "ko": "도트"
    },
    "55": {
      "type": "pattern",
      "en": "camouflage",
      "ko": "카모플라쥬"
    },
    "56": {
      "type": "pattern",
      "en": "leopard",
      "ko": "호피"
    },
    "57": {
      "type": "pattern",
      "en": "ethnic",
      "ko": "에스닉"
    },
    "58": {
      "type": "pattern",
      "en": "paisley",
      "ko": "페이즐리"
    },
    "59": {
      "type": "pattern",
      "en": "geometry",
      "ko": "기하학"
    },
    "60": {
      "type": "pattern",
      "en": "plain",
      "ko": "민무늬"
    },
    "61": {
      "type": "pattern",
      "en": "print",
      "ko": "프린트"
    }
  },
  "fabric": {
    "70": {
      "type": "fabric",
      "en": "none",
      "ko": "없음"
    },
    "71": {
      "type": "fabric",
      "en": "leather",
      "ko": "가죽"
    },
    "72": {
      "type": "fabric",
      "en": "cotton",
      "ko": "면"
    },
    "73": {
      "type": "fabric",
      "en": "knit\/angora",
      "ko": "니트\/앙고라"
    },
    "74": {
      "type": "fabric",
      "en": "fur",
      "ko": "퍼"
    },
    "75": {
      "type": "fabric",
      "en": "denim",
      "ko": "데님"
    },
    "76": {
      "type": "fabric",
      "en": "suede\/velvet",
      "ko": "스웨이드\/벨벳"
    },
    "77": {
      "type": "fabric",
      "en": "chiffon\/silk",
      "ko": "쉬폰\/실크"
    },
    "78": {
      "type": "fabric",
      "en": "linen",
      "ko": "리넨"
    },
    "79": {
      "type": "fabric",
      "en": "lace\/mesh",
      "ko": "레이스\/매쉬"
    },
    "80": {
      "type": "fabric",
      "en": "tweed",
      "ko": "트위드"
    },
    "81": {
      "type": "fabric",
      "en": "sequin\/spangle",
      "ko": "시퀸\/스팽글"
    },
    "82": {
      "type": "fabric",
      "en": "polyester",
      "ko": "폴리에스터"
    }
  },
  "neckline": {
    "90": {
      "type": "neckline",
      "en": "none",
      "ko": "없음"
    },
    "91": {
      "type": "neckline",
      "en": "round neck",
      "ko": "라운드넥"
    },
    "92": {
      "type": "neckline",
      "en": "v neck",
      "ko": "브이넥"
    },
    "93": {
      "type": "neckline",
      "en": "square neck",
      "ko": "스퀘어넥"
    },
    "94": {
      "type": "neckline",
      "en": "turtle neck",
      "ko": "터틀넥"
    },
    "95": {
      "type": "neckline",
      "en": "off shoulder",
      "ko": "오프숄더"
    },
    "96": {
      "type": "neckline",
      "en": "one shoulder",
      "ko": "원숄더"
    },
    "97": {
      "type": "neckline",
      "en": "henley neck",
      "ko": "헨리넥"
    },
    "98": {
      "type": "neckline",
      "en": "boat neck",
      "ko": "보트넥"
    },
    "99": {
      "type": "neckline",
      "en": "halter neck",
      "ko": "홀터넥"
    },
    "100": {
      "type": "neckline",
      "en": "collar neck",
      "ko": "칼라넥"
    },
    "101": {
      "type": "neckline",
      "en": "cowl neck",
      "ko": "카울넥"
    },
    "102": {
      "type": "neckline",
      "en": "hood collar",
      "ko": "후드 칼라"
    },
    "103": {
      "type": "neckline",
      "en": "strapless",
      "ko": "스트랩리스"
    }
  },
  "length_of_tops": {
    "110": {
      "type": "length_of_tops",
      "en": "none",
      "ko": "없음"
    },
    "111": {
      "type": "length_of_tops",
      "en": "crop",
      "ko": "크롭"
    },
    "112": {
      "type": "length_of_tops",
      "en": "medium",
      "ko": "미듐"
    },
    "113": {
      "type": "length_of_tops",
      "en": "long",
      "ko": "롱"
    }
  },
  "length_of_one-piece": {
    "115": {
      "type": "length_of_one-piece",
      "en": "none",
      "ko": "없음"
    },
    "116": {
      "type": "length_of_one-piece",
      "en": "mini",
      "ko": "미니"
    },
    "117": {
      "type": "length_of_one-piece",
      "en": "midi",
      "ko": "미디"
    },
    "118": {
      "type": "length_of_one-piece",
      "en": "long",
      "ko": "롱"
    }
  },
  "length_of_sleeve": {
    "120": {
      "type": "length_of_sleeve",
      "en": "none",
      "ko": "없음"
    },
    "121": {
      "type": "length_of_sleeve",
      "en": "long sleeve",
      "ko": "긴팔"
    },
    "122": {
      "type": "length_of_sleeve",
      "en": "three quarter sleeve",
      "ko": "7부 소매"
    },
    "123": {
      "type": "length_of_sleeve",
      "en": "short sleeve",
      "ko": "반팔"
    },
    "124": {
      "type": "length_of_sleeve",
      "en": "sleeveless",
      "ko": "민소매"
    }
  },
  "kind_of_sleeve": {
    "130": {
      "type": "kind_of_sleeve",
      "en": "none",
      "ko": "없음"
    },
    "131": {
      "type": "kind_of_sleeve",
      "en": "set-in sleeve",
      "ko": "세트인 슬리브"
    },
    "132": {
      "type": "kind_of_sleeve",
      "en": "drop shoulder sleeve",
      "ko": "드롭숄더 슬리브"
    },
    "133": {
      "type": "kind_of_sleeve",
      "en": "raglan sleeve",
      "ko": "래글런 슬리브"
    },
    "134": {
      "type": "kind_of_sleeve",
      "en": "puff sleeve",
      "ko": "퍼프 슬리브"
    },
    "135": {
      "type": "kind_of_sleeve",
      "en": "trumpet sleeve",
      "ko": "와이드 슬리브"
    },
    "136": {
      "type": "kind_of_sleeve",
      "en": "dolman sleeve",
      "ko": "돌먼 슬리브"
    },
    "137": {
      "type": "kind_of_sleeve",
      "en": "flutter sleeve",
      "ko": "날개 슬리브"
    }
  },
  "shape_of_pants": {
    "150": {
      "type": "shape_of_pants",
      "en": "none",
      "ko": "없음"
    },
    "151": {
      "type": "shape_of_pants",
      "en": "skinny",
      "ko": "스키니"
    },
    "152": {
      "type": "shape_of_pants",
      "en": "straight",
      "ko": "스트레이트"
    },
    "153": {
      "type": "shape_of_pants",
      "en": "boot-cut",
      "ko": "부츠컷"
    },
    "154": {
      "type": "shape_of_pants",
      "en": "wide",
      "ko": "와이드"
    },
    "155": {
      "type": "shape_of_pants",
      "en": "baggy",
      "ko": "배기"
    },
    "156": {
      "type": "shape_of_pants",
      "en": "leggings",
      "ko": "레깅스"
    }
  },
  "shape_of_skirts": {
    "160": {
      "type": "shape_of_skirts",
      "en": "none",
      "ko": "없음"
    },
    "161": {
      "type": "shape_of_skirts",
      "en": "H line",
      "ko": "H라인"
    },
    "162": {
      "type": "shape_of_skirts",
      "en": "flare",
      "ko": "플레어"
    },
    "163": {
      "type": "shape_of_skirts",
      "en": "A line",
      "ko": "A라인"
    },
    "164": {
      "type": "shape_of_skirts",
      "en": "pleats",
      "ko": "플리츠"
    },
    "165": {
      "type": "shape_of_skirts",
      "en": "mermaid",
      "ko": "머메이드"
    },
    "166": {
      "type": "shape_of_skirts",
      "en": "wrap",
      "ko": "랩"
    },
    "167": {
      "type": "shape_of_skirts",
      "en": "tiered",
      "ko": "캉캉"
    }
  },
  "shape_of_dresses": {
    "170": {
      "type": "shape_of_dresses",
      "en": "none",
      "ko": "없음"
    },
    "171": {
      "type": "shape_of_dresses",
      "en": "H line",
      "ko": "H라인"
    },
    "172": {
      "type": "shape_of_dresses",
      "en": "A line",
      "ko": "A라인"
    },
    "173": {
      "type": "shape_of_dresses",
      "en": "wrap",
      "ko": "랩"
    }
  },
  "color": {
    "181": {
      "type": "color",
      "en": "black",
      "ko": "블랙"
    },
    "182": {
      "type": "color",
      "en": "gray",
      "ko": "그레이"
    },
    "183": {
      "type": "color",
      "en": "silver",
      "ko": "실버"
    },
    "184": {
      "type": "color",
      "en": "white",
      "ko": "화이트"
    },
    "185": {
      "type": "color",
      "en": "brown",
      "ko": "브라운"
    },
    "186": {
      "type": "color",
      "en": "olive",
      "ko": "카키"
    },
    "187": {
      "type": "color",
      "en": "navy",
      "ko": "네이비"
    },
    "188": {
      "type": "color",
      "en": "orange",
      "ko": "오렌지"
    },
    "189": {
      "type": "color",
      "en": "yellow",
      "ko": "옐로우"
    },
    "190": {
      "type": "color",
      "en": "gold",
      "ko": "골드"
    },
    "191": {
      "type": "color",
      "en": "green",
      "ko": "그린"
    },
    "192": {
      "type": "color",
      "en": "skyblue",
      "ko": "스카이블루"
    },
    "193": {
      "type": "color",
      "en": "blue",
      "ko": "블루"
    },
    "194": {
      "type": "color",
      "en": "purple",
      "ko": "퍼플"
    },
    "195": {
      "type": "color",
      "en": "pink",
      "ko": "핑크"
    },
    "196": {
      "type": "color",
      "en": "red",
      "ko": "레드"
    },
    "197": {
      "type": "color",
      "en": "beige",
      "ko": "베이지"
    }
  }
};

export const FLEX_MODE = {
  "filter": 0,
  "naive": 1
};

export const CATEGORIES_FOR_RECOMMEND = [16, 32, 207, 2, 4, 8, 210, 211];

export const DEMO_IMAGES = [
  "naning9_007.png",
  "chichera_001.jpg",
  "chichera_002.jpg",
  "chichera_003.jpg",
  "chichera_006.jpg",
  "chichera_007.jpg",
  "chichera_008.jpg",
  "chichera_009.png",
  "chichera_010.png",
  "chichera_011.png",
  "chichera_012.png",
  "demo_25.jpg",
  "demo_30.jpg",
  "demo_40.jpg",
  "demo_41.jpg",
  "demo_47.jpg",
  "demo_49.jpg",
  "nain_001.jpg",
  "nain_006.jpg",
  "nain_007.jpg",
  "naning9_005.jpg",
  "naning9_006.png",
  "naning9_008.png",
  "naning9_009.png",
  "naning9_010.png",
  "naning9_011.png",
  "naning9_012.png",
  "naning9_013.png",
  "suggesty_004.jpg",
];
